import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import styles from "./FacultyProfile.module.css";
import { AxiosInstance } from "../../../../axios";
// import { ImageUrlPrefix, LBL_BASIC_DETAILS } from "../../../../labels";
import "./Profile.css";
import React, { useState, useEffect, useRef } from "react";
// import {} from "../../../../pages/TechnicalQualification";
import { Link, useNavigate, useParams } from "react-router-dom";
// import { Download } from "@mui/icons-material";
import { validateProfile } from "./ValidateProfile";
import intlTelInput from "intl-tel-input";
import moment from "moment";
import { validateForms } from "./validation";
// import CategorySubject from "./CategorySubject";
// import ReadViewSubject from "./ReadViewSubject";
// import Select, { components, useStateManager } from "react-select";
// import { customStyles } from "../../../../pages/customStyles";
// import DatePickerSample from "../../DatePicker";
// import MonthDatePicker from "../../MonthDatePicker";
// import { TechFaculty } from "./TechFaculty";
import toast from "react-hot-toast";
import FacultyProfileStep1 from "./FacultyProfileStep1";
import FacultyProfileStep2 from "./FacultyProfileStep2";
import FacultyProfileStep3 from "./FacultyProfileStep3";
import FacultyProfileStep4 from "./FacultyProfileStep4";
import FacultyProfileStep5 from "./FacultyProfileStep5";
import Loader from "../../Loader";

function FacultyProfile() {
  const userJSON = sessionStorage.getItem("userDetails");
  let user_type = null;
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
    if (user && user.user_type) {
      user_type = user.user_type;
    }
  } else {
    console.log("user not available in session storage");
  }

  //fields use current fields focus

  const txtAdFname = useRef(null);
  const txtAdLname = useRef(null);
  const txtAdAge = useRef(null);
  const txtAdPlaceBrith = useRef(null);
  const txtAdMDob = useRef(null);
  const txtAdMStatus = useRef(null);
  const txtAdSpouse = useRef(null);
  const txtAdOccupation = useRef(null);
  const txtAdGender = useRef(null);
  const txtAdFath = useRef(null);
  const txtAdMoth = useRef(null);
  const txtAdPSize = useRef(null);
  const txtAdAno = useRef(null);
  const txtAdApath = useRef(null);
  const txtAdpno = useRef(null);
  const txtAdPpath = useRef(null);
  const txtAdPno = useRef(null);
  const txtAdWno = useRef(null);
  const txtAdFpo = useRef(null);
  const txtAdEmail = useRef(null);
  const txtAdPhno = useRef(null);
  const txtAdPsname = useRef(null);
  const txtAdParea = useRef(null);
  const txtAdPland = useRef(null);
  const txtAdPpost = useRef(null);
  const txtAdPtaluk = useRef(null);
  const txtAdPpincode = useRef(null);
  const txtAdPcity = useRef(null);
  const txtAdPstate = useRef(null);
  const txtAdPdistrict = useRef(null);
  const txtAdPerhno = useRef(null);
  const txtAdPersname = useRef(null);
  const txtAdPerarea = useRef(null);
  const txtAdPerland = useRef(null);
  const txtAdPererpost = useRef(null);
  const txtAdPertaluk = useRef(null);
  const txtAdPerpincode = useRef(null);
  const txtAdPercity = useRef(null);
  const txtAdPerstate = useRef(null);
  const txtAdPerdistrict = useRef(null);

  const txtAdEduc = useRef(null);

  const txtAdUCer = useRef(null);
  const txtAdUpass = useRef(null);
  const txtAdUmarks = useRef(null);
  const txtAdUdeg = useRef(null);
  const txtAdUMaj = useRef(null);
  const txtAdUMajOther = useRef(null);
  const txtAdUclass = useRef(null);
  const txtAdUins = useRef(null);
  const txtAdUfile = useRef(null);

  const txtAdPhdCer = useRef(null);
  const txtAdPhdpass = useRef(null);
  const txtAdPhdmarks = useRef(null);
  const txtAdPhddeg = useRef(null);
  const txtAdPhdMaj = useRef(null);
  const txtadVerifyHere = useRef(null);
  const txtAdPhdclass = useRef(null);
  const txtAdPhdins = useRef(null);
  const txtAdPhdfile = useRef(null);
  const txtAdPCer = useRef(null);
  const txtAdPpass = useRef(null);
  const txtAdPmarks = useRef(null);
  const txtAdPdeg = useRef(null);
  const txtAdPMaj = useRef(null);
  const txtAdPMajOther = useRef(null);
  const txtAdIMajOther = useRef(null);
  const txtAdDMajOther = useRef(null);
  const txtAdPhdMajOther = useRef(null);
  const txtAdCMajOther = useRef(null);
  const txtAdPclass = useRef(null);
  const txtAdPins = useRef(null);
  const txtAdPfile = useRef(null);
  const txtAdICer = useRef(null);
  const txtAdIpass = useRef(null);
  const txtAdImarks = useRef(null);
  const txtAdIdeg = useRef(null);
  const txtAdIMaj = useRef(null);
  const txtAdIclass = useRef(null);
  const txtAdIins = useRef(null);
  const txtAdIfile = useRef(null);
  const txtAdDCer = useRef(null);
  const txtAdDpass = useRef(null);
  const txtAdDmarks = useRef(null);
  const txtAdDdeg = useRef(null);
  const txtAdDMaj = useRef(null);
  const txtAdDclass = useRef(null);
  const txtAdDins = useRef(null);
  const txtAdDfile = useRef(null);
  const txtAdCCer = useRef(null);
  const txtAdCpass = useRef(null);
  const txtAdCmarks = useRef(null);
  const txtAdCdeg = useRef(null);
  const txtAdCMaj = useRef(null);
  const txtAdCclass = useRef(null);
  const txtAdCins = useRef(null);
  const txtAdCfile = useRef(null);
  const txtAdOCer = useRef(null);
  const txtAdOpass = useRef(null);
  const txtAdOmarks = useRef(null);
  const txtAdOdeg = useRef(null);
  const txtAdOMaj = useRef(null);
  const txtAdOclass = useRef(null);
  const txtAdOins = useRef(null);
  const txtAdOfile = useRef(null);
  const txtAdSpc = useRef(null);
  const txtadTech = useRef(null);
  const txtAdWorkingexp = useRef(null);
  const txtAdTeachingexp = useRef(null);
  const txtAdDes = useRef(null);
  const txtAdDjoin = useRef(null);
  const txtfacLoc = useRef(null);
  const txtAdVoicepp = useRef(null);
  const txtWfile = useRef(null);
  const txtTfile = useRef(null);
  const adminstatusRef = useRef(null);
  const commentsRef = useRef(null);

  const { userId } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  //useState for all dropdown , input fields
  const [pgDegree, setPGDegree] = useState([]);
  const [ipgDegree, setIPGDegree] = useState([]);
  const [readbatch, setReadbatch] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
  const [readSpecialpre, setReadSpecialpre] = useState([]);
  const [step, setStep] = useState(1);
  const [cOption, setCOption] = useState([]);
  const [catOption, setCatOption] = useState([]);
  const [teachMedium, setTeachMedium] = useState([]);
  const [examination, setExamination] = useState([]);
  const [previousexam, setPreviousexam] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [technicalOption, setTechnicalOption] = useState([]);
  const [pcDegree, setPCDegree] = useState([]);
  const [phDegree, setPhDegree] = useState([]);
  const [diplomaDegree, setDiplomaDegree] = useState([]);
  const [categoryOption, setCategoryOption] = useState([]);
  const [coursesCate, setCoursesCate] = useState([]);
  const [city, setCity] = useState([]);
  const [major, setMajor] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [locations, setLocations] = useState([]);
  const [specialPrefrence, setSpecialPrefrence] = useState([]);
  const [ugDegree, setUGDegree] = useState([]);
  const [pgMajor, setPgMajor] = useState([]);
  const [ipMajor, setIpMajor] = useState([]);
  const [PhMajor, setPhMajor] = useState([]);

  const [dmajor, setDmajor] = useState([]);
  const [pcMajor, setPcmajor] = useState([]);
  const [otMajor, setOTmajor] = useState([]);
  const [listErrors, setListErrors] = useState({});
  const [categoryJob, setCategoryJob] = useState([]);
  // AIASA-000125 - v1 issues solved by lalitha
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, [step]);
  const [addJob, setAddJob] = useState([
    {
      department_id: "",
      department: "",
      designation_id: "",
      exp_designation: "",
      designationOptions: [],
    },
  ]);
  const [errDep, setErrDep] = useState([]);
  const [department, setDepartment] = useState([]);

  const [list, setList] = useState({
    FirstName: "",
    LastName: "",
    Fathername: "",
    DOB: "",
    age: 0,
    PlaceBirth: "",
    gender: "Male",
    MaritalStatus: "Single/Unmarried",
    Spouse: "",
    Occupation: "",
    Mobile: "",
    WhatsAppNumber: "",
    MobileCode: "+91",
    WhatsAppNumberCode: "+91",
    ContactNumber: false,
    emailaddress: "",
    Profilephoto: null,
    status: 0,
    aadharNo: "",
    aadharCardphoto: null,
    panNo: "",
    panPhoto: null,
    BuildingNumberPresent: "",
    BuildingNumberPresent: "",
    StreetNamePresent: "",
    AreaPresent: "",
    LandmarkPresent: "",
    districtPresent: "",
    CityPresent: "",
    statePresent: "",
    PostPresent: "",
    TalukPresent: "",
    PincodePresent: 0,
    SamePresentAddress: false,
    BuildingNumberPermanent: "",
    StreetNamePermanent: "",
    AreaPermanent: "",
    LandmarkPermanent: "",
    CityPermanent: "",
    districtPermanent: "",
    statePermanent: "",
    PincodePermanent: 0,
    PostPermanent: "",
    TalukPermanent: "",
    spq: "",
    prevTeachexp: "Yes",
    workingexp: "",
    teachexp: "",
    teachType: "",
    staff_type: "",
    designation: "",
    designation_id: "",
    DJoin: "",
    VoiceOpinion: "",
    Verify: false,
    Adminstatus: "",
    comments: "",
    working_ex_file: null,
    Teaching_ex_file: null,
    original_aadhar_path: null,
    original_profile_path: null,
    original_caste_path: null,
    original_pan_path: null,
    original_workexp: null,
    original_teachexp: null,
    location: "",
    location_id: "",
    location_name: "",
  });

  const [category, setCategory] = useState([]);
  const [classOption, setClassOption] = useState([]);
  const [subject, setSubject] = useState([]);

  const [uGisOther, setUGIsOther] = useState(false);
  const [pGisOther, setPGIsOther] = useState(false);
  const [pHDisOther, setPHDIsOther] = useState(false);
  const [iPGisOther, setIPGIsOther] = useState(false);
  const [dipisOther, setDipIsOther] = useState(false);
  const [pCisOther, setPCIsOther] = useState(false);

  const [ugOption, setUgOption] = useState({
    UG: null,
    PG: null,
    Integrated_PG: null,
    phd: null,
    Diploma: null,
    Professional_Courses: null,
  });

  const [mOption, setMOption] = useState({
    UGMajor: null,
    UGClassName: null,
    PGMajor: null,
    PGClassName: null,
    IPMajor: null,
    IPClassName: null,
    PHDMajor: null,
    PHDClassName: null,
    DMajor: null,
    DClassName: null,
    PCMajor: null,
    PCClassName: null,
    OtClassName: null,
  });
  const [educationQualification, setEducationQualification] = useState(["UG"]);

  //education useState
  const [sslcCerficates, setSslcCerficates] = useState([
    {
      name: "UG",
      UGCertificateNumber: "",
      UGYearpassing: "",
      UGDegree: "",
      UGMajor: "",
      UGMajor_Other: "",
      UGMarksPercentage: "",
      UGClassName: "",
      UGNameInstitute: "",
      UG_Path: null,
      original_file_path: null,
    },
    {
      name: "PG",
      PGCertificateNumber: "",
      PGYearpassing: "",
      PGDegree: "",
      PGMajor: "",
      PGMajor_Other: "",
      PGMarksPercentage: "",
      PGClassName: "",
      PGNameInstitute: "",
      PG_Path: null,
      original_file_path: null,
    },
    {
      name: "Integrated PG",
      IPCertificateNumber: "",
      IPYearpassing: "",
      IPDegree: "",
      IPMajor: "",
      IPMajor_Other: "",
      IPMarksPercentage: "",
      IPClassName: "",
      IPNameInstitute: "",
      IP_Path: null,
      original_file_path: null,
    },
    {
      name: "phd",
      PHDCertificateNumber: "",
      PHDYearpassing: "",
      PHDDegree: "",
      PHDMajor: "",
      PHDMajor_Other: "",
      PHDMarksPercentage: "",
      PHDClassName: "",
      PHDNameInstitute: "",
      PHD_Path: null,
      original_file_path: null,
    },
    {
      name: "Diploma",
      DCertificateNumber: "",
      DYearpassing: "",
      DDegree: "",
      DMajor: "",
      DMajor_other: "",
      DMarksPercentage: "",
      DClassName: "",
      DNameInstitute: "",
      D_Path: null,
      original_file_path: null,
    },
    {
      name: "Professional Courses",
      PCCertificateNumber: "",
      PCYearpassing: "",
      PCDegree: "",
      PCMajor: "",
      PCMajor_Other: "",
      PCMarksPercentage: "",
      PCClassName: "",
      PCNameInstitute: "",
      PC_Path: null,
      original_file_path: null,
    },
    {
      name: "Others",
      OtCertificateNumber: "",
      OtYearpassing: "",
      OtDegree: "",
      OtMajor: "",
      OtMarksPercentage: "",
      OtClassName: "",
      OtNameInstitute: "",
      Ot_Path: null,
      original_file_path: null,
    },
  ]);
  //technical qualification
  const [techQualification, setTechQualification] = useState([
    {
      id: 0,
      name: "",
      level: "",
      lang: "",
      Cnum: "",
      grade: "",
      kComputer: "",
      year: "",
      file: "",
      error_name: "",
      error_certificate_no: "",
      error_year_of_passing: "",
      error_level: "",
      error_grade: "",
      error_certificate_path: "",
      error_kComputer: "",
    },
  ]);
  //date and time convert to normal data
  const dobCon = (userdate) => {
    if (!userdate) {
      return ""; // Handle empty input
    }
    const date = new Date(userdate);
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return ""; // Handle invalid date
    }
    // Extract the year, month, and day components
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getUTCDate()).padStart(2, "0");
    // Format the date as "YYYY-MM-DD"
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };
  const GetDesignation = (depId, index) => {
    console.log("+++++++++++++++=");

    AxiosInstance.get(`api/all/getDesignation/3/${depId}`)
      .then((res) => {
        const designationOptions = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item) => ({
            value: item.id,
            label: item.name,
          }));

        setAddJob((prevJobs) => {
          const updatedJobs = [...prevJobs];
          updatedJobs[index] = {
            ...updatedJobs[index],
            designationOptions: designationOptions,
          };

          return updatedJobs;
        });
      })
      .catch((error) => {
        return error;
      });
  };

  useEffect(() => {
    if (userId) {
      AxiosInstance.post("api/staff/view", {
        user_id: userId,
      })
        .then((res) => {
          const userinfo = res.data.data;
          const PersonDetails = {
            FirstName: userinfo.first_name,
            LastName: userinfo.last_name,
            Fathername: userinfo.father_name,
            MotherName: userinfo.mother_name,
            Profilephoto:
              userinfo.profile_path !== null ? userinfo.profile_path : null,
            original_aadhar_path: userinfo.original_aadhar_path,
            original_profile_path: userinfo.original_profile_path,
            // original_caste_path:userinfo.original_caste_path,
            original_pan_path: userinfo.original_pan_path,
            DOB: userinfo.dob !== null ? dobCon(userinfo.dob) : "",
            //  DOB: "2000-07-29",
            PlaceBirth: userinfo.place_of_birth,
            age: userinfo.age,
            gender: userinfo.gender,
            MaritalStatus: userinfo.marital_status,
            Spouse: userinfo.spouse_name,
            Occupation: userinfo.spouse_ocp,
            aadharNo: userinfo.aadhar_no,
            aadharCardphoto:
              userinfo.aadhar_path !== null ? userinfo.aadhar_path : null,
            panNo: userinfo.pan_no,
            panPhoto: userinfo.pan_path,
            Mobile: userinfo.mobile_no,
            WhatsAppNumber: userinfo.whatsapp_no,
            MobileCode:
              userinfo.country_code !== null ? userinfo.country_code : "+91",
            WhatsAppNumberCode:
              userinfo.country_code !== null ? userinfo.country_code : "+91",
            ContactNumber: userinfo.contact_type === 0 ? false : true,
            emailaddress: userinfo.email,
            spq: userinfo.special_qualification,
            prevTeachexp: userinfo.experience === 1 ? "Yes" : "NO",
            workingexp: userinfo.working_exp,
            teachexp: userinfo.teaching_exp,
            working_ex_file: userinfo.working_exp_filepath,
            Teaching_ex_file: userinfo.teaching_exp_filepath,
            original_workexp: userinfo.original_workexp,
            original_teachexp: userinfo.original_teachexp,
            designation: userinfo.designation,
            designation_id: userinfo.designation_id,
            teachType:
              userinfo.is_eligible_class === 0 ||
              userinfo.is_eligible_class === "0"
                ? "0"
                : "1",
            staff_type: userinfo.staff_type,
            DJoin:
              userinfo.aiasa_doj !== null && userinfo.aiasa_doj !== ""
                ? dobCon(userinfo.aiasa_doj)
                : "",
            location: userinfo.staff_loc_name,
            location_id: userinfo.staff_loc_id,
            location_name: userinfo.staff_loc_name,
            VoiceOpinion: userinfo.feedback,
            Adminstatus:userinfo.status
          };
          setList(PersonDetails);
          const addj = userinfo.job_info.map((item, index) => ({
            id: index + 1,
            department: item.department || "",
            department_id: item.department_id || "",
            designation_id: item.designation_id || "",
            exp_designation: item.exp_designation || "",
          }));
          setAddJob(addj);

          userinfo.address.map((obj) => {
            if (obj.address_type === 1) {
              PersonDetails.SamePresentAddress =
                obj.same_address === 0 ? true : false;
              PersonDetails.BuildingNumberPresent = obj.address1;
              PersonDetails.StreetNamePresent = obj.address2;
              PersonDetails.AreaPresent = obj.address3;
              PersonDetails.LandmarkPresent = obj.landmark;
              PersonDetails.districtPresent = obj.district_name;
              PersonDetails.CityPresent = obj.city;
              PersonDetails.statePresent = obj.state_name;
              PersonDetails.PostPresent = obj.post_name;
              PersonDetails.TalukPresent = obj.taluk;
              PersonDetails.PincodePresent = obj.postal_code;
            } else {
              PersonDetails.SamePresentAddress =
                obj.same_address === 0 ? true : false;
              PersonDetails.BuildingNumberPermanent = obj.address1;
              PersonDetails.StreetNamePermanent = obj.address2;
              PersonDetails.AreaPermanent = obj.address3;
              PersonDetails.LandmarkPermanent = obj.landmark;
              PersonDetails.districtPermanent = obj.district_name;
              PersonDetails.CityPermanent = obj.city;
              PersonDetails.statePermanent = obj.state_name;
              PersonDetails.PostPermanent = obj.post_name;
              PersonDetails.TalukPermanent = obj.taluk;
              PersonDetails.PincodePermanent = obj.postal_code;
            }
          });
          let edq = userinfo.edu
            .filter((item) => item.qualification_type === "EDQ")
            .map((obj) => {
              let name = "";
              if (obj.name === "sslc") {
                name = "SSLC";
              } else if (obj.name === "hsc") {
                name = "HSC";
              } else {
                name = obj.name;
              }
              return name;
            });

          setEducationQualification(edq);
          let sslcCert = userinfo.edu
            .filter((item) => item.qualification_type === "EDQ")
            .map((el, index) => {
              if (el.name === "UG") {
                const matchingCertificate = {};
                if (el.type_of_degree === 1) {
                  setUGIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["UGMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["UGMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }
                setUgOption((prevState) => ({
                  ...prevState,
                  ["UG"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.UGCertificateNumber = el.certificate_no;
                matchingCertificate.UGYearpassing = el.year_of_passing;
                matchingCertificate.UGDegree = el.degree_name;
                matchingCertificate.UGMajor_Other = el.major_subject;
                matchingCertificate.UGMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.UGMarksPercentage = el.marks_percentage;
                matchingCertificate.UGClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["UGClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.UGNameInstitute = el.institute;
                matchingCertificate.UG_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "PG") {
                const matchingCertificate = {};
                if (el.type_of_degree === 1) {
                  setPGIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PGMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PGMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }

                setUgOption((prevState) => ({
                  ...prevState,
                  ["PG"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.PGCertificateNumber = el.certificate_no;
                matchingCertificate.PGYearpassing = el.year_of_passing;
                matchingCertificate.PGMarksPercentage = el.marks_percentage;
                matchingCertificate.PGDegree = el.degree_name;
                matchingCertificate.PGMajor_Other = el.major_subject;
                matchingCertificate.PGMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.PGClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["PGClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.PGNameInstitute = el.institute;
                matchingCertificate.PG_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "Integrated PG") {
                const matchingCertificate = {};
                if (el.type_of_degree === 1) {
                  setIPGIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["IPMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["IPMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }

                setUgOption((prevState) => ({
                  ...prevState,
                  ["Integrated_PG"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.IPCertificateNumber = el.certificate_no;
                matchingCertificate.IPYearpassing = el.year_of_passing;
                matchingCertificate.IPDegree = el.degree_name;
                matchingCertificate.IPMajor_Other = el.major_subject;
                matchingCertificate.IPMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.IPMarksPercentage = el.marks_percentage;
                matchingCertificate.IPClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["IPClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.IPNameInstitute = el.institute;
                matchingCertificate.IP_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "phd") {
                const matchingCertificate = {};
                if (el.type_of_degree === 1) {
                  setPHDIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PHDMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PHDMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }
                setUgOption((prevState) => ({
                  ...prevState,
                  ["phd"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.PHDCertificateNumber = el.certificate_no;
                matchingCertificate.PHDYearpassing = el.year_of_passing;
                matchingCertificate.PHDDegree = el.degree_name;
                matchingCertificate.PHDMajor_Other = el.major_subject;
                matchingCertificate.PHDMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.PHDMarksPercentage = el.marks_percentage;
                matchingCertificate.PHDClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["PHDClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.PHDNameInstitute = el.institute;
                matchingCertificate.PHD_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "Diploma") {
                const matchingCertificate = {};
                if (el.type_of_degree === 1) {
                  setDipIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["DMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["DMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }
                setUgOption((prevState) => ({
                  ...prevState,
                  ["Diploma"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.DCertificateNumber = el.certificate_no;
                matchingCertificate.DYearpassing = el.year_of_passing;
                matchingCertificate.DDegree = el.degree_name;
                matchingCertificate.DMajor_Other = el.major_subject;
                matchingCertificate.DMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.DMarksPercentage = el.marks_percentage;
                matchingCertificate.DClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["DClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.DNameInstitute = el.institute;
                matchingCertificate.D_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "Professional Courses") {
                const matchingCertificate = {};

                if (el.type_of_degree === 1) {
                  setPCIsOther(true);
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PCMajor"]: {
                      value: "Others",
                      label: "Others",
                    },
                  }));
                } else {
                  setMOption((prevState) => ({
                    ...prevState,
                    ["PCMajor"]: {
                      value: el.major_subject,
                      label: el.major_subject,
                    },
                  }));
                }

                setUgOption((prevState) => ({
                  ...prevState,
                  ["Professional_Courses"]: {
                    value: el.degree_name,
                    label: el.degree_name,
                  },
                }));

                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.PCCertificateNumber = el.certificate_no;
                matchingCertificate.PCYearpassing = el.year_of_passing;
                matchingCertificate.PCDegree = el.degree_name;
                matchingCertificate.PCMajor_Other = el.major_subject;
                matchingCertificate.PCMajor =
                  el.type_of_degree === 1 ? "Others" : el.major_subject;
                matchingCertificate.PCMarksPercentage = el.marks_percentage;
                matchingCertificate.PCClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;
                setMOption((prevState) => ({
                  ...prevState,
                  ["PCClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.PCNameInstitute = el.institute;
                matchingCertificate.PC_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              } else if (el.name === "Others") {
                const matchingCertificate = {};
                // if a matching certificate is found, update its properties
                matchingCertificate.name = el.name;
                matchingCertificate.OtCertificateNumber = el.certificate_no;
                matchingCertificate.OtYearpassing = el.year_of_passing;
                matchingCertificate.OtDegree = el.degree_name;
                matchingCertificate.OtMajor = el.major_subject;
                matchingCertificate.OtMarksPercentage = el.marks_percentage;
                matchingCertificate.OtClassName = el.grade;
                matchingCertificate.original_file_path = el.original_file_path;

                setMOption((prevState) => ({
                  ...prevState,
                  ["OtClassName"]: {
                    value: el.grade,
                    label: el.grade,
                  },
                }));
                matchingCertificate.OtNameInstitute = el.institute;
                matchingCertificate.Ot_Path = el.certificate_path;
                setSslcCerficates((prevState) => {
                  return prevState.map((q) => {
                    if (q.name === el.name) {
                      // return { ...q, matchingCertificate };
                      return matchingCertificate;
                    }
                    return q;
                  });
                });
              }
            });

          let teach = userinfo.edu
            .filter((item) => item.qualification_type === "THQ")
            .map((el, index) => {
              const Teachqu = {};

              // if a matching certificate is found, update its properties
              // Teachqu.id = index === 0 ? 1 : index + 1;
              Teachqu.id = el.id ? el.id : 0;
              Teachqu.name = el.name;
              Teachqu.level = el.level;
              Teachqu.lang = el.edu_medium;
              Teachqu.Cnum = el.certificate_no;
              Teachqu.grade = el.grade;
              Teachqu.kComputer = el.kdg_in_com;
              Teachqu.year = el.year_of_passing;
              Teachqu.file = el.certificate_path;
              Teachqu.error_name = "";
              Teachqu.error_certificate_no = "";
              Teachqu.error_year_of_passing = "";
              Teachqu.error_level = "";
              Teachqu.error_grade = "";
              Teachqu.error_certificate_path = "";
              Teachqu.error_kComputer = "";
              Teachqu.original_file_path = el.original_file_path;

              return Teachqu;
            });
          setTechQualification(teach);
        })
        .catch((error) => {
          return error;
        });
    }
  }, [userId]);

  // Faculty profile read api for all steps
  useEffect(() => {
    if (!userId) {
      const userJSON = sessionStorage.getItem("userDetails");
      if (userJSON) {
        const user = JSON.parse(userJSON);
        if (user && user.user_id) {
          const userid = user.user_id;
          AxiosInstance.post("api/staff/view", {
            user_id: userid,
          })
            .then((res) => {
              const userinfo = res.data.data;
              const PersonDetails = {
                FirstName: userinfo.first_name,
                LastName: userinfo.last_name,
                Fathername: userinfo.father_name,
                MotherName: userinfo.mother_name,
                Profilephoto:
                  userinfo.profile_path !== null ? userinfo.profile_path : null,
                original_aadhar_path: userinfo.original_aadhar_path,
                original_profile_path: userinfo.original_profile_path,
                // original_caste_path:userinfo.original_caste_path,
                original_pan_path: userinfo.original_pan_path,
                DOB: userinfo.dob !== null ? dobCon(userinfo.dob) : "",
                //  DOB: "2000-07-29",
                PlaceBirth: userinfo.place_of_birth,
                age: userinfo.age,
                gender: userinfo.gender,
                MaritalStatus: userinfo.marital_status,
                Spouse: userinfo.spouse_name,
                Occupation: userinfo.spouse_ocp,
                aadharNo: userinfo.aadhar_no,
                aadharCardphoto:
                  userinfo.aadhar_path !== null ? userinfo.aadhar_path : null,
                panNo: userinfo.pan_no,
                panPhoto: userinfo.pan_path,
                Mobile: userinfo.mobile_no,
                WhatsAppNumber: userinfo.whatsapp_no,
                MobileCode:
                  userinfo.country_code !== null
                    ? userinfo.country_code
                    : "+91",
                WhatsAppNumberCode:
                  userinfo.country_code !== null
                    ? userinfo.country_code
                    : "+91",
                ContactNumber: userinfo.contact_type === 0 ? false : true,
                emailaddress: userinfo.email,
                spq: userinfo.special_qualification,
                prevTeachexp: userinfo.experience === 1 ? "Yes" : "NO",
                workingexp: userinfo.working_exp,
                teachexp: userinfo.teaching_exp,
                working_ex_file: userinfo.working_exp_filepath,
                Teaching_ex_file: userinfo.teaching_exp_filepath,
                original_workexp: userinfo.original_workexp,
                original_teachexp: userinfo.original_teachexp,
                designation: userinfo.designation,
                designation_id: userinfo.designation_id,
                teachType:
                  userinfo.is_eligible_class === 0 ||
                  userinfo.is_eligible_class === "0"
                    ? "0"
                    : "1",
                staff_type: userinfo.staff_type,
                DJoin:
                  userinfo.aiasa_doj !== null && userinfo.aiasa_doj !== ""
                    ? dobCon(userinfo.aiasa_doj)
                    : "",
                location: userinfo.staff_loc_name,
                location_id: userinfo.staff_loc_id,
                location_name: userinfo.staff_loc_name,
                VoiceOpinion: userinfo.feedback,
                Adminstatus:userinfo.status
              };

              setList(PersonDetails);
              const addj = userinfo.job_info.map((item, index) => ({
                id: index + 1,
                department: item.department || "",
                department_id: item.department_id || "",
                designation_id: item.designation_id || "",
                exp_designation: item.exp_designation || "",
              }));
              setAddJob(addj);

              userinfo.address.map((obj) => {
                if (obj.address_type === 1) {
                  PersonDetails.SamePresentAddress =
                    obj.same_address === 0 ? true : false;
                  PersonDetails.BuildingNumberPresent = obj.address1;
                  PersonDetails.StreetNamePresent = obj.address2;
                  PersonDetails.AreaPresent = obj.address3;
                  PersonDetails.LandmarkPresent = obj.landmark;
                  PersonDetails.districtPresent = obj.district_name;
                  PersonDetails.CityPresent = obj.city;
                  PersonDetails.statePresent = obj.state_name;
                  PersonDetails.PostPresent = obj.post_name;
                  PersonDetails.TalukPresent = obj.taluk;
                  PersonDetails.PincodePresent = obj.postal_code;
                } else {
                  PersonDetails.SamePresentAddress =
                    obj.same_address === 0 ? true : false;
                  PersonDetails.BuildingNumberPermanent = obj.address1;
                  PersonDetails.StreetNamePermanent = obj.address2;
                  PersonDetails.AreaPermanent = obj.address3;
                  PersonDetails.LandmarkPermanent = obj.landmark;
                  PersonDetails.districtPermanent = obj.district_name;
                  PersonDetails.CityPermanent = obj.city;
                  PersonDetails.statePermanent = obj.state_name;
                  PersonDetails.PostPermanent = obj.post_name;
                  PersonDetails.TalukPermanent = obj.taluk;
                  PersonDetails.PincodePermanent = obj.postal_code;
                }
              });

              let edq = userinfo.edu
                .filter((item) => item.qualification_type === "EDQ")
                .map((obj) => {
                  let name = "";
                  if (obj.name === "sslc") {
                    name = "SSLC";
                  } else if (obj.name === "hsc") {
                    name = "HSC";
                  } else {
                    name = obj.name;
                  }
                  return name;
                });

              setEducationQualification(edq);
              let sslcCert = userinfo.edu
                .filter((item) => item.qualification_type === "EDQ")
                .map((el, index) => {
                  if (el.name === "UG") {
                    const matchingCertificate = {};
                    if (el.type_of_degree === 1) {
                      setUGIsOther(true);
                      setMOption((prevState) => ({
                        ...prevState,
                        ["UGMajor"]: {
                          value: "Others",
                          label: "Others",
                        },
                      }));
                    } else {
                      setMOption((prevState) => ({
                        ...prevState,
                        ["UGMajor"]: {
                          value: el.major_subject,
                          label: el.major_subject,
                        },
                      }));
                    }
                    setUgOption((prevState) => ({
                      ...prevState,
                      ["UG"]: {
                        value: el.degree_name,
                        label: el.degree_name,
                      },
                    }));

                    // if a matching certificate is found, update its properties
                    matchingCertificate.name = el.name;
                    matchingCertificate.UGCertificateNumber = el.certificate_no;
                    matchingCertificate.UGYearpassing = el.year_of_passing;
                    matchingCertificate.UGDegree = el.degree_name;
                    matchingCertificate.UGMajor_Other = el.major_subject;
                    matchingCertificate.UGMajor =
                      el.type_of_degree === 1 ? "Others" : el.major_subject;
                    matchingCertificate.UGMarksPercentage = el.marks_percentage;
                    matchingCertificate.UGClassName = el.grade;
                    matchingCertificate.original_file_path =
                      el.original_file_path;
                    setMOption((prevState) => ({
                      ...prevState,
                      ["UGClassName"]: {
                        value: el.grade,
                        label: el.grade,
                      },
                    }));
                    matchingCertificate.UGNameInstitute = el.institute;
                    matchingCertificate.UG_Path = el.certificate_path;
                    setSslcCerficates((prevState) => {
                      return prevState.map((q) => {
                        if (q.name === el.name) {
                          // return { ...q, matchingCertificate };
                          return matchingCertificate;
                        }
                        return q;
                      });
                    });
                  } else if (el.name === "PG") {
                    const matchingCertificate = {};
                    if (el.type_of_degree === 1) {
                      setPGIsOther(true);
                      setMOption((prevState) => ({
                        ...prevState,
                        ["PGMajor"]: {
                          value: "Others",
                          label: "Others",
                        },
                      }));
                    } else {
                      setMOption((prevState) => ({
                        ...prevState,
                        ["PGMajor"]: {
                          value: el.major_subject,
                          label: el.major_subject,
                        },
                      }));
                    }

                    setUgOption((prevState) => ({
                      ...prevState,
                      ["PG"]: {
                        value: el.degree_name,
                        label: el.degree_name,
                      },
                    }));

                    // if a matching certificate is found, update its properties
                    matchingCertificate.name = el.name;
                    matchingCertificate.PGCertificateNumber = el.certificate_no;
                    matchingCertificate.PGYearpassing = el.year_of_passing;
                    matchingCertificate.PGMarksPercentage = el.marks_percentage;
                    matchingCertificate.PGDegree = el.degree_name;
                    matchingCertificate.PGMajor_Other = el.major_subject;
                    matchingCertificate.PGMajor =
                      el.type_of_degree === 1 ? "Others" : el.major_subject;
                    matchingCertificate.PGClassName = el.grade;
                    matchingCertificate.original_file_path =
                      el.original_file_path;
                    setMOption((prevState) => ({
                      ...prevState,
                      ["PGClassName"]: {
                        value: el.grade,
                        label: el.grade,
                      },
                    }));
                    matchingCertificate.PGNameInstitute = el.institute;
                    matchingCertificate.PG_Path = el.certificate_path;
                    setSslcCerficates((prevState) => {
                      return prevState.map((q) => {
                        if (q.name === el.name) {
                          return matchingCertificate;
                        }
                        return q;
                      });
                    });
                  } else if (el.name === "Integrated PG") {
                    const matchingCertificate = {};
                    if (el.type_of_degree === 1) {
                      setIPGIsOther(true);
                      setMOption((prevState) => ({
                        ...prevState,
                        ["IPMajor"]: {
                          value: "Others",
                          label: "Others",
                        },
                      }));
                    } else {
                      setMOption((prevState) => ({
                        ...prevState,
                        ["IPMajor"]: {
                          value: el.major_subject,
                          label: el.major_subject,
                        },
                      }));
                    }

                    setUgOption((prevState) => ({
                      ...prevState,
                      ["Integrated_PG"]: {
                        value: el.degree_name,
                        label: el.degree_name,
                      },
                    }));

                    // if a matching certificate is found, update its properties
                    matchingCertificate.name = el.name;
                    matchingCertificate.IPCertificateNumber = el.certificate_no;
                    matchingCertificate.IPYearpassing = el.year_of_passing;
                    matchingCertificate.IPDegree = el.degree_name;
                    matchingCertificate.IPMajor_Other = el.major_subject;
                    matchingCertificate.IPMajor =
                      el.type_of_degree === 1 ? "Others" : el.major_subject;
                    matchingCertificate.IPMarksPercentage = el.marks_percentage;
                    matchingCertificate.IPClassName = el.grade;
                    matchingCertificate.original_file_path =
                      el.original_file_path;
                    setMOption((prevState) => ({
                      ...prevState,
                      ["IPClassName"]: {
                        value: el.grade,
                        label: el.grade,
                      },
                    }));
                    matchingCertificate.IPNameInstitute = el.institute;
                    matchingCertificate.IP_Path = el.certificate_path;
                    setSslcCerficates((prevState) => {
                      return prevState.map((q) => {
                        if (q.name === el.name) {
                          // return { ...q, matchingCertificate };
                          return matchingCertificate;
                        }
                        return q;
                      });
                    });
                  } else if (el.name === "phd") {
                    const matchingCertificate = {};
                    if (el.type_of_degree === 1) {
                      setPHDIsOther(true);
                      setMOption((prevState) => ({
                        ...prevState,
                        ["PHDMajor"]: {
                          value: "Others",
                          label: "Others",
                        },
                      }));
                    } else {
                      setMOption((prevState) => ({
                        ...prevState,
                        ["PHDMajor"]: {
                          value: el.major_subject,
                          label: el.major_subject,
                        },
                      }));
                    }
                    setUgOption((prevState) => ({
                      ...prevState,
                      ["phd"]: {
                        value: el.degree_name,
                        label: el.degree_name,
                      },
                    }));

                    // if a matching certificate is found, update its properties
                    matchingCertificate.name = el.name;
                    matchingCertificate.PHDCertificateNumber =
                      el.certificate_no;
                    matchingCertificate.PHDYearpassing = el.year_of_passing;
                    matchingCertificate.PHDDegree = el.degree_name;
                    matchingCertificate.PHDMajor_Other = el.major_subject;
                    matchingCertificate.PHDMajor =
                      el.type_of_degree === 1 ? "Others" : el.major_subject;
                    matchingCertificate.PHDMarksPercentage =
                      el.marks_percentage;
                    matchingCertificate.PHDClassName = el.grade;
                    matchingCertificate.original_file_path =
                      el.original_file_path;
                    setMOption((prevState) => ({
                      ...prevState,
                      ["PHDClassName"]: {
                        value: el.grade,
                        label: el.grade,
                      },
                    }));
                    matchingCertificate.PHDNameInstitute = el.institute;
                    matchingCertificate.PHD_Path = el.certificate_path;
                    setSslcCerficates((prevState) => {
                      return prevState.map((q) => {
                        if (q.name === el.name) {
                          // return { ...q, matchingCertificate };
                          return matchingCertificate;
                        }
                        return q;
                      });
                    });
                  } else if (el.name === "Diploma") {
                    const matchingCertificate = {};
                    if (el.type_of_degree === 1) {
                      setDipIsOther(true);
                      setMOption((prevState) => ({
                        ...prevState,
                        ["DMajor"]: {
                          value: "Others",
                          label: "Others",
                        },
                      }));
                    } else {
                      setMOption((prevState) => ({
                        ...prevState,
                        ["DMajor"]: {
                          value: el.major_subject,
                          label: el.major_subject,
                        },
                      }));
                    }
                    setUgOption((prevState) => ({
                      ...prevState,
                      ["Diploma"]: {
                        value: el.degree_name,
                        label: el.degree_name,
                      },
                    }));

                    // if a matching certificate is found, update its properties
                    matchingCertificate.name = el.name;
                    matchingCertificate.DCertificateNumber = el.certificate_no;
                    matchingCertificate.DYearpassing = el.year_of_passing;
                    matchingCertificate.DDegree = el.degree_name;
                    matchingCertificate.DMajor_Other = el.major_subject;
                    matchingCertificate.DMajor =
                      el.type_of_degree === 1 ? "Others" : el.major_subject;
                    matchingCertificate.DMarksPercentage = el.marks_percentage;
                    matchingCertificate.DClassName = el.grade;
                    matchingCertificate.original_file_path =
                      el.original_file_path;
                    setMOption((prevState) => ({
                      ...prevState,
                      ["DClassName"]: {
                        value: el.grade,
                        label: el.grade,
                      },
                    }));
                    matchingCertificate.DNameInstitute = el.institute;
                    matchingCertificate.D_Path = el.certificate_path;
                    setSslcCerficates((prevState) => {
                      return prevState.map((q) => {
                        if (q.name === el.name) {
                          // return { ...q, matchingCertificate };
                          return matchingCertificate;
                        }
                        return q;
                      });
                    });
                  } else if (el.name === "Professional Courses") {
                    const matchingCertificate = {};

                    if (el.type_of_degree === 1) {
                      setPCIsOther(true);
                      setMOption((prevState) => ({
                        ...prevState,
                        ["PCMajor"]: {
                          value: "Others",
                          label: "Others",
                        },
                      }));
                    } else {
                      setMOption((prevState) => ({
                        ...prevState,
                        ["PCMajor"]: {
                          value: el.major_subject,
                          label: el.major_subject,
                        },
                      }));
                    }

                    setUgOption((prevState) => ({
                      ...prevState,
                      ["Professional_Courses"]: {
                        value: el.degree_name,
                        label: el.degree_name,
                      },
                    }));

                    // if a matching certificate is found, update its properties
                    matchingCertificate.name = el.name;
                    matchingCertificate.PCCertificateNumber = el.certificate_no;
                    matchingCertificate.PCYearpassing = el.year_of_passing;
                    matchingCertificate.PCDegree = el.degree_name;
                    matchingCertificate.PCMajor_Other = el.major_subject;
                    matchingCertificate.PCMajor =
                      el.type_of_degree === 1 ? "Others" : el.major_subject;
                    matchingCertificate.PCMarksPercentage = el.marks_percentage;
                    matchingCertificate.PCClassName = el.grade;
                    matchingCertificate.original_file_path =
                      el.original_file_path;
                    setMOption((prevState) => ({
                      ...prevState,
                      ["PCClassName"]: {
                        value: el.grade,
                        label: el.grade,
                      },
                    }));
                    matchingCertificate.PCNameInstitute = el.institute;
                    matchingCertificate.PC_Path = el.certificate_path;
                    setSslcCerficates((prevState) => {
                      return prevState.map((q) => {
                        if (q.name === el.name) {
                          // return { ...q, matchingCertificate };
                          return matchingCertificate;
                        }
                        return q;
                      });
                    });
                  } else if (el.name === "Others") {
                    const matchingCertificate = {};
                    // if a matching certificate is found, update its properties
                    matchingCertificate.name = el.name;
                    matchingCertificate.OtCertificateNumber = el.certificate_no;
                    matchingCertificate.OtYearpassing = el.year_of_passing;
                    matchingCertificate.OtDegree = el.degree_name;
                    matchingCertificate.OtMajor = el.major_subject;
                    matchingCertificate.OtMarksPercentage = el.marks_percentage;
                    matchingCertificate.OtClassName = el.grade;
                    matchingCertificate.original_file_path =
                      el.original_file_path;

                    setMOption((prevState) => ({
                      ...prevState,
                      ["OtClassName"]: {
                        value: el.grade,
                        label: el.grade,
                      },
                    }));
                    matchingCertificate.OtNameInstitute = el.institute;
                    matchingCertificate.Ot_Path = el.certificate_path;
                    setSslcCerficates((prevState) => {
                      return prevState.map((q) => {
                        if (q.name === el.name) {
                          // return { ...q, matchingCertificate };
                          return matchingCertificate;
                        }
                        return q;
                      });
                    });
                  }
                });

              let teach = userinfo.edu
                .filter((item) => item.qualification_type === "THQ")
                .map((el, index) => {
                  const Teachqu = {};

                  // if a matching certificate is found, update its properties
                  // Teachqu.id = index === 0 ? 1 : index + 1;
                  Teachqu.id = el.id ? el.id : 0;
                  Teachqu.name = el.name;
                  Teachqu.level = el.level;
                  Teachqu.lang = el.edu_medium;
                  Teachqu.Cnum = el.certificate_no;
                  Teachqu.grade = el.grade;
                  Teachqu.kComputer = el.kdg_in_com;
                  Teachqu.year = el.year_of_passing;
                  Teachqu.file = el.certificate_path;
                  Teachqu.error_name = "";
                  Teachqu.error_certificate_no = "";
                  Teachqu.error_year_of_passing = "";
                  Teachqu.error_level = "";
                  Teachqu.error_grade = "";
                  Teachqu.error_certificate_path = "";
                  Teachqu.error_kComputer = "";
                  Teachqu.original_file_path = el.original_file_path;

                  return Teachqu;
                });
              setTechQualification(teach);
            })
            .catch((error) => {
              return error;
            });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (step === 1) {
      // Initialize intl-tel-input on component mount
      const iti = intlTelInput(txtAdPno.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdPno.current.addEventListener("countrychange", () => {
        // console.log('Country changed:', iti.getSelectedCountryData());
        const selectedCountryData = iti.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          MobileCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      const iti_wha = intlTelInput(txtAdWno.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdWno.current.addEventListener("countrychange", () => {
        // console.log('Country changed:', iti_wha.getSelectedCountryData());
        const selectedCountryData = iti_wha.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          WhatsAppNumberCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      // Clean up on component unmount
      return () => {
        iti.destroy();
        iti_wha.destroy();
      };
    }
  }, [step]);

  const getallSubject = (sub, name) => {
    AxiosInstance.post("api/course/subject", { category_name: name, type: 0 })
      .then((res) => {
        if (res.data.data.length > 0) {
          // const subjects = res.data.data.map((item, index) => (
          //   <option id={index} key={index} value={item.subject}>
          //     {item.subject}
          //   </option>
          // ));
          const subjects = [];
          res.data.data.map((item, index) => {
            subjects.push({
              value: item.subject + "",
              label: item.subject + "",
              pk: item.id,
            });
          });
          // setCate(subject);
          let subs = [];
          sub.map((obj) => {
            if (obj.category === name) {
              obj.subject_name = subjects;
            }
            subs.push(obj);
          });
          setSubject(subs);
        } else {
          // const option = (
          //   <option key="select" value="select">
          //     Please select
          //   </option>
          // );
          const subjects = [];
          let subs = [];
          sub.map((obj) => {
            if (obj.category === name) {
              obj.subject_name = subjects;
            }
            subs.push(obj);
          });
          setSubject(subs);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const getallSubjectView = (sub, name, options) => {
    AxiosInstance.post("api/course/subject", { category_name: name, type: 0 })
      .then((res) => {
        if (res.data.data.length > 0) {
          // const subjects = res.data.data.map((item, index) => (
          //   <option id={index} key={index} value={item.subject}>
          //     {item.subject}
          //   </option>
          // ));
          const subjects = [];
          res.data.data.map((item, index) => {
            subjects.push({
              value: item.subject + "",
              label: item.subject + "",
              pk: item.id,
            });
          });
          // setCate(subject);
          let subs = [];
          sub.map((obj) => {
            if (obj.category === name) {
              obj.subject_name = subjects;
              obj.optionSelected = options;
            }
            subs.push(obj);
          });
          setSubject(subs);
        } else {
          // const option = (
          //   <option key="select" value="select">
          //     Please select
          //   </option>
          // );
          const subjects = [];
          let subs = [];
          sub.map((obj) => {
            if (obj.category === name) {
              obj.subject_name = subjects;
            }
            subs.push(obj);
          });
          setSubject(subs);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (!userId) {
      const userJSON = sessionStorage.getItem("userDetails");
      if (userJSON) {
        const user = JSON.parse(userJSON);
        if (user && user.user_id) {
          const userid = user.user_id;
          const StepFive = {
            step: 5,
            user_id: userid,
            updated_by: userid,
          };
          // console.log(StepFive, "StepFive");
          if (list.Verify === true) {
            AxiosInstance.post("/api/staff/add", StepFive)
              .then((res) => {
                // console.log(res);
                if (res.data.status === true) {
                  toast.success(res.data.message);
                  navigate("/");
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          } else {
            let err = "Please look and verify the Terms and Conditions.";
            txtadVerifyHere.current.focus();
            setListErrors({
              ...listErrors,
              Verify: err,
            });
          }
        }
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    if (user_type === 1) {
      errors = validateForms(list);
      if (errors.Adminstatus) {
        adminstatusRef.current?.focus();
      } else if (errors.comments) {
        commentsRef.current?.focus();
      }
    } else {
      errors = {};
    }

    if (Object.keys(errors).length === 0) {
      try {
        const userJSON = sessionStorage.getItem("userDetails");
        if (userJSON) {
          const user = JSON.parse(userJSON);
          if (user && user.user_id) {
            const userid = user.user_id;
            // console.log(userid, "userid", userId);
            const reqdata = {
              user_id: userId ? userId : userid,
              updated_by: userid,
              status: parseInt(list.Adminstatus),
              comments: list.comments,
            };
              setIsLoading(true);
            // console.log(reqdata);
            const response = await AxiosInstance.post(
              "api/staff/approval",
              reqdata
            );
            if (response.data.status === true) {
                 setIsLoading(false);
              toast.success(response.data.message);
              if (user_type === 1) {
                navigate("/Faculties");
              } else {
                navigate("/");
              }
            } else {
              toast.error(response.data.message);
            }
          }
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    } else {
      setListErrors(errors);
    }
  };

  const handleCategoryChanges = (e, name) => {
    // const { name, value } = e.target;
    // console.log("radio select ", e.target.value);
    if (e.target.checked) {
      handleAddSubject(e.target.value);
      setCategory([...category, e.target.value]);
      setListErrors({
        ...listErrors,
        category: "",
      });
    } else {
      handleDelSubject(e.target.value);
      setCategory(category.filter((item) => item !== e.target.value));
    }
  };
  const handleChangeCheckbox = (e, recordID) => {
    let subs = [];
    //subject.filter((item) => item.id !== e.id);
    subject.map((obj, index) => {
      if (obj.id === recordID) {
        obj.optionSelected = e;
      }
      subs.push(obj);
    });
    setSubject(subs);
    setListErrors({
      ...listErrors,
      optionSelected: "",
    });
  };

  const handleAddSubject = (name) => {
    // console.log("Add subject", subject);
    let subs = [];
    subject.map((obj) => {
      subs.push(obj);
    });
    subs.push({
      id: subject.length + 1,
      category: "" + name,
      subject_name: [],
      optionSelected: null,
    });
    // setSubject(subs);
    getallSubject(subs, name);
  };

  const handleDelSubject = (name) => {
    //const { name, value } = e.target;
    // console.log("DEL ", name);
    let subs = subject.filter((item) => item.category !== name);
    subs.map((obj, index) => {
      obj.id = index + 1;
      subs[index] = obj;
    });
    setSubject(subs);
  };

  useEffect(() => {
    AxiosInstance.get("api/all/getDepartment/3")
      .then((res) => {
        const sortedDepartments = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => ({
            value: item.id,
            label: item.name,
            id: item.id,
          }));
        setDepartment(sortedDepartments);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDesignation/0/0")
      .then((res) => {
        const designation = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => ({
            value: item.id,
            label: item.name,
          }));
        setDesignation(designation);
      })
      .catch((error) => {
        return error;
      });
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        if (res.data.data.length > 0) {
          const loc = res.data.data
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((item, index) => ({
              value: item.id,
              label: item.name,
            }));
          setLocations(loc);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  // useEffect(() => {
  //   if (categoryJob.includes("UPSC") ) {
  //     AxiosInstance.post("api/course/subject",{"category_name":"UPSC"})
  //       .then((res) => {
  //         if (res.data.data.length > 0) {
  //           const subject = res.data.data.map((item) => (
  //             <option key={item.subject} value={item.subject}>
  //               {item.subject}
  //             </option>
  //           ));
  //           setSubjectDropdown(subject);
  //         } else {
  //           const option = (
  //             <option key="select" value="select">
  //               Please select
  //             </option>
  //           );
  //           setSubjectDropdown(option);
  //         }
  //       })
  //       .catch((error) => {
  //         return error;
  //       });
  //   }

  // }, [categoryJob.includes("UPSC")]);

  useEffect(() => {
    if (sslcCerficates[0].UGDegree !== "") {
      const bbb = {
        degree_name: sslcCerficates[0].UGDegree,
        type: "UG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, bbb)
        .then((res) => {
          if (res.data.data.length > 0) {
            // in response duplicate entry come means its showing extra data in next api call option
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const majorOptions = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const majorOptions = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            // const additionalOptions = [
            //   { value: "Others", label: "Others" },
            // ];
            // // Append the additional objects to the majorOptions array
            // const updatedMajorOptions = majorOptions.concat(additionalOptions);
            // // Set the state with the updated array
            setMajor(majorOptions);
          } else {
            setMajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[0].UGDegree]);

  useEffect(() => {
    if (sslcCerficates[1].PGDegree !== "") {
      const bbbs = {
        degree_name: sslcCerficates[1].PGDegree,
        type: "PG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, bbbs)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const pgMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const pgMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setPgMajor(pgMajor);
          } else {
            // const option = (
            //   <option key="select" value="select">
            //     Please select
            //   </option>
            // );
            setPgMajor([]);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[1].PGDegree]);

  useEffect(() => {
    if (sslcCerficates[2].IPDegree !== "") {
      const bbbss = {
        degree_name: sslcCerficates[2].IPDegree,
        type: "IPG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, bbbss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const IpMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const IpMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setIpMajor(IpMajor);
          } else {
            setIpMajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[2].IPDegree]);

  useEffect(() => {
    if (sslcCerficates[3].PHDDegree !== "") {
      const bbbsss = {
        degree_name: sslcCerficates[3].PHDDegree,
        type: "phd",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, bbbsss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const PhMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const PhMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            const additionalOptions = [{ value: "Others", label: "Others" }];
            // Append the additional objects to the majorOptions array
            const updatedMajorOptions = PhMajor.concat(additionalOptions);
            // Set the state with the updated array

            setPhMajor(updatedMajorOptions);
          } else {
            // const option = (
            //   <option key="select" value="select">
            //     Please select
            //   </option>
            // );
            setPhMajor(null);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[3].PHDDegree]);

  useEffect(() => {
    if (sslcCerficates[4].DDegree !== "") {
      const bbbsss = {
        degree_name: sslcCerficates[4].DDegree,
        type: "diploma",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, bbbsss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const dmajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const dmajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setDmajor(dmajor);
          } else {
            setDmajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[4].DDegree]);

  useEffect(() => {
    if (sslcCerficates[5].PCDegree !== "") {
      const bbbsss = {
        degree_name: sslcCerficates[5].PCDegree,
        type: "PC",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, bbbsss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const pcMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const pcMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setPcmajor(pcMajor);
          } else {
            setPcmajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[5].PCDegree]);

  useEffect(() => {
    if (sslcCerficates[6].OtDegree !== "") {
      AxiosInstance.get(`api/all/getDegreeMajor/${sslcCerficates[6].OtDegree}`)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const OtMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const OtMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setOTmajor(OtMajor);
          } else {
            // const option = (
            //   <option key="select" value="select">
            //     Please select
            //   </option>
            // );
            setOTmajor(null);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[6].OtDegree]);

  //major,designation , department , exam details , degree  dropdown
  useEffect(() => {
    AxiosInstance.get("api/all/getDegreeNames/UG")
      .then((res) => {
        // const ugDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const ugDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setUGDegree(ugDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/PHD")
      .then((res) => {
        // const phDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const phDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setPhDegree(phDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/PG")
      .then((res) => {
        // const pgDegree = res.data.data.map((item, index) => (
        //   <option key={index} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const pgDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setPGDegree(pgDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/IPG")
      .then((res) => {
        // const ipgDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const ipgDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setIPGDegree(ipgDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/diploma")
      .then((res) => {
        // const diplomaDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const diplomaDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setDiplomaDegree(diplomaDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/PC")
      .then((res) => {
        // const pcDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const pcDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setPCDegree(pcDegree);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  //when pincode enter city dropdown , state , district  fill with ui
  useEffect(() => {
    if (list.PincodePresent !== "") {
      AxiosInstance.get(`api/all/getAddress/${list.PincodePresent}`)
        .then((res) => {
          let code = res.data.data;
          // const city = code.map((item, index) => (
          //   <option key={index} value={item.city}>
          //     {item.city}
          //   </option>
          // ));
          const city = code.map((item, index) => ({
            value: item.city,
            label: item.city,
          }));
          setCity(city);
          list.statePresent = code[0].state;
          list.districtPresent = code[0].district;
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.PincodePresent]);
  useEffect(() => {
    if (list.PincodePermanent !== "") {
      AxiosInstance.get(`api/all/getAddress/${list.PincodePermanent}`)
        .then((res) => {
          let code = res.data.data;
          const city = code.map((item, index) => ({
            value: item.city,
            label: item.city,
          }));
          setCity(city);
          list.statePermanent = code[0].state;
          list.districtPermanent = code[0].district;
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.PincodePermanent]);

  //dropdown api call
  useEffect(() => {
    // get response from api to fill dropdowns

    AxiosInstance.get("api/codevalues?codetype=EDQ")
      .then((res) => {
        const educationOptions = res.data.map((item) => (
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setEducationOptions(educationOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CLASS_EDQ")
      .then((res) => {
        // const classOptions = res.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const classOptions = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setClassOption(classOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=THQ")
      .then((res) => {
        const technicalOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        // Sort the options alphabetically, ignoring "Nil"
        const sortedOptions = technicalOption
          .filter((item) => item.value !== "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        const NilOption = technicalOption
          .filter((item) => item.value === "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        // Set the sorted list to the state
        sortedOptions.push(...NilOption);
        setTechnicalOption(sortedOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CTGY")
      .then((res) => {
        const categoryOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setCategoryOption(categoryOption);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=ASP")
      .then((res) => {
        const specialPrefrence = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        // Sort the options alphabetically, ignoring "Nil"
        const sortedOptions = specialPrefrence
          .filter((item) => item.value !== "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        const NilOption = specialPrefrence
          .filter((item) => item.value === "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        // Set the sorted list to the state
        sortedOptions.push(...NilOption);
        setSpecialPrefrence(sortedOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CURS")
      .then((res) => {
        const cOption = res.data.map((item) => (
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setCOption(cOption);
        setCatOption(res.data);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=MDP")
      .then((res) => {
        const teachMedium = res.data.map((item) => (
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setTeachMedium(teachMedium);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  //when pincode enter city dropdown , state , district  fill with ui -- end

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    const checked = event.target.checked;

    if (checked) {
      setEducationQualification([...educationQualification, value]);
      setListErrors({
        ...listErrors,
        EducationQualification: "",
      });
    } else {
      AxiosInstance.post("api/course/admission/delete/qualifications", {
        user_id: userId,
        name: value,
        qualification_type: "EDQ",
      })
        .then((res) => {
          // console.log(res);
          if (res.status === 200) {
            setEducationQualification(
              educationQualification.filter((item) => item !== value)
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  };

  //technical qualification add function
  const AddQualification = () => {
    if (technicalOption.length > techQualification.length) {
      setTechQualification((prevState) => [
        ...prevState,
        {
          id: 0,
          // id: prevState.length > 0 ? prevState.length + 1 : 1,
          name: "",
          level: "",
          lang: "",
          Cnum: "",
          kComputer: "",
          grade: "",
          year: "",
          file: "",
          error_name: "",
          edu_medium: "",
          error_certificate_no: "",
          error_year_of_passing: "",
          error_level: "",
          error_grade: "",
          error_certificate_path: "",
          error_kComputer: "",
        },
      ]);
    } else {
      toast.error("you reach more Technical Qualification");
    }
  };
  //technical qualification delete function
  const DeleteQual = (index, name) => {
    AxiosInstance.post("api/course/admission/delete/qualifications", {
      user_id: userId,
      name: name,
      qualification_type: "THQ",
      // id: id,
    })
      .then((res) => {
        if (res.status === 200) {
          const updatedQualifications = techQualification.filter(
            (_, i) => i !== index
          );
          setTechQualification(updatedQualifications);
          // const updatedQualifications = techQualification
          //   .filter((_, i) => i !== index)
          //   .map((item, i) => ({ ...item, index: i + 1 }));

          // setTechQualification(updatedQualifications);
        }
      })
      .catch((error) => {
        return error;
      });
  };
  const setMaxMonthYearTec = (value) => {
    // console.log(value);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Month is zero-based

    // Format the current month and year as "yyyy-MM"
    const maxMonthYear = `${currentYear}-${currentMonth
      .toString()
      .padStart(2, "0")}`;
    // Parse the provided value into a JavaScript Date object
    const selectedDate = new Date(value);

    if (selectedDate > currentDate) {
      alert("Year of passing should be in past");
    } else {
      // Return the value because it's not in the future
      return value;
    }
  };

  const TechhandleChanges = (option, index, dname) => {
    setTechQualification((prevState) => {
      const updated = [...prevState];
      const item = { ...updated[index] };

      if (dname === "name") {
        item["name"] = option.value;
        item["error_name"] = "";
      } else {
        item["kComputer"] = option.value;
        item["error_kComputer"] = "";
      }

      updated[index] = item;
      return updated;
    });
  };

  const TechhandleChange_date = (date, index, name) => {
    const dateEYD = moment(date).format("YYYY-MM");
    if (setMaxMonthYearTec(dateEYD)) {
      setTechQualification((prevState) => {
        const updated = [...prevState];
        updated[index][name] = dateEYD;
        updated[index]["error_year_of_passing"] = "";
        return updated;
      });
    }
  };

  //technical qualification handle change  function
  const TechhandleChange = (e, index) => {
    // Handle react-select object format
    if (e && e.__fieldName) {
      const name = e.__fieldName;
      const value = e.value;

      setTechQualification((prevState) => {
        const updated = [...prevState];
        updated[index] = {
          ...updated[index],
          [name]: value,
          ...(name === "grade" && { error_grade: "" }),
          ...(name === "level" && { error_level: "" }),
          ...(name === "lang" && { error_edu_medium: "" }),
        };
        return updated;
      });
      return;
    }

    // Handle native event from input/select/file inputs
    const { name, value, files } = e.target;

    if (name === "file" && files && files.length > 0) {
      const TQ_path = files[0];

      if (TQ_path.type === "application/pdf") {
        if (TQ_path.size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("TQ_path", TQ_path);

          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setTechQualification((prevState) => {
                const updated = [...prevState];
                updated[index] = {
                  ...updated[index],
                  file: res.data.path,
                  original_file_path: res.data.originalname,
                };
                return updated;
              });
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });
        } else {
          alert("File must be less than 2MB");
        }
      }
      return;
    }

    // Validation and update for year
    if (name === "year") {
      if (setMaxMonthYearTec(value)) {
        setTechQualification((prevState) => {
          const updated = [...prevState];
          updated[index] = {
            ...updated[index],
            [name]: value,
            error_year_of_passing: "",
          };
          return updated;
        });
      }
      return;
    }

    // Validation for certificate number
    if (name === "Cnum") {
      if (!/^[A-Za-z0-9]*$/.test(value)) {
        alert("Certificate number can only contain letters and numbers");
      } else {
        setTechQualification((prevState) => {
          const updated = [...prevState];
          updated[index] = {
            ...updated[index],
            [name]: value,
            error_certificate_no: "",
          };
          return updated;
        });
      }
      return;
    }

    // Default handling for other fields
    setTechQualification((prevState) => {
      const updated = [...prevState];
      updated[index] = {
        ...updated[index],
        [name]: value,
      };

      // Reset relevant error field
      if (name === "grade") updated[index].error_grade = "";
      if (name === "kComputer") updated[index].error_kComputer = "";
      if (name === "level") updated[index].error_level = "";
      if (name === "lang") updated[index].error_edu_medium = "";

      return updated;
    });
  };

  const setMaxMonthYear = (value, names) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Month is zero-based

    // Format the current month and year as "yyyy-MM"
    const maxMonthYear = `${currentYear}-${currentMonth
      .toString()
      .padStart(2, "0")}`;

    // Parse the provided value into a JavaScript Date object
    const selectedDate = new Date(value);

    if (selectedDate > currentDate) {
      setListErrors({
        ...listErrors,
        [names]: "Year of passing should be in past",
      });
    } else {
      // Return the value because it's not in the future
      return value;
    }
  };
  const handleEdus = (option, name, dname) => {
    if (name === "Integrated PG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Integrated_PG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["IPMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "Professional Courses") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Professional_Courses"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["PCMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "UG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["UG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["UGMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "PG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["PG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["PGMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "Diploma") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Diploma"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["DMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "phd") {
      setUgOption((prevState) => ({
        ...prevState,
        ["phd"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["PHDMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else {
      setUgOption((prevState) => ({
        ...prevState,
        [name]: option,
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    }
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };

  const handleEduMajor = (option, name, dname) => {
    if (option.label === "Others" && name === "UG" && dname === "UGMajor") {
      setUGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "UG" &&
      dname === "UGMajor"
    ) {
      setUGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "PG" &&
      dname === "PGMajor"
    ) {
      setPGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "PG" &&
      dname === "PGMajor"
    ) {
      setPGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Integrated PG" &&
      dname === "IPMajor"
    ) {
      setIPGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Integrated PG" &&
      dname === "IPMajor"
    ) {
      setIPGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Diploma" &&
      dname === "DMajor"
    ) {
      setDipIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Diploma" &&
      dname === "DMajor"
    ) {
      setDipIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "phd" &&
      dname === "PHDMajor"
    ) {
      setPHDIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "phd" &&
      dname === "PHDMajor"
    ) {
      setPHDIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Professional Courses" &&
      dname === "PCMajor"
    ) {
      setPCIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Professional Courses" &&
      dname === "PCMajor"
    ) {
      setPCIsOther(false);
    }
    setMOption((prevState) => ({
      ...prevState,
      [dname]: option,
    }));
    setSslcCerficates((prevState) => {
      return prevState.map((q) => {
        if (q.name === name) {
          return { ...q, [dname]: option.value };
        }
        return q;
      });
    });
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };

  const handleEYDate = (dates, name, dname) => {
    const dateEYD = moment(dates).format("YYYY-MM");
    // console.log(name, "name", dname, dateEYD);
    if (setMaxMonthYear(dateEYD, name)) {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === dname) {
            return { ...q, [name]: dateEYD };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === dname) {
            return { ...q, [name]: "" };
          }
          return q;
        });
      });
    }
  };

  const handleYearChange_month = (year, dname) => {
    if (dname === "UGYearpassing") {
      if (
        sslcCerficates[0].UGYearpassing !== null &&
        sslcCerficates[0].UGYearpassing !== "" &&
        sslcCerficates[0].UGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[0].UGYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["UGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "UG") {
              return { ...q, ["UGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["UGYearpassing"]: "",
        });
      }
    } else if (dname === "PGYearpassing") {
      if (
        sslcCerficates[1].PGYearpassing !== null &&
        sslcCerficates[1].PGYearpassing !== "" &&
        sslcCerficates[1].PGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[1].PGYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "PG") {
              return { ...q, ["PGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PGYearpassing"]: "",
        });
      }
    } else if (dname === "IPYearpassing") {
      if (
        sslcCerficates[2].IPYearpassing !== null &&
        sslcCerficates[2].IPYearpassing !== "" &&
        sslcCerficates[2].IPYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[2].IPYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["IPYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Integrated PG") {
              return { ...q, ["IPYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["IPYearpassing"]: "",
        });
      }
    } else if (dname === "PHDYearpassing") {
      if (
        sslcCerficates[3].PHDYearpassing !== null &&
        sslcCerficates[3].PHDYearpassing !== "" &&
        sslcCerficates[3].PHDYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[3].PHDYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "phd") {
                return { ...q, ["PHDYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PHDYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "phd") {
                return { ...q, ["PHDYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "phd") {
              return { ...q, ["PHDYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PHDYearpassing"]: "",
        });
      }
    } else if (dname === "DYearpassing") {
      if (
        sslcCerficates[4].DYearpassing !== null &&
        sslcCerficates[4].DYearpassing !== "" &&
        sslcCerficates[4].DYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[4].DYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["DYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Diploma") {
              return { ...q, ["DYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["DYearpassing"]: "",
        });
      }
    } else if (dname === "PCYearpassing") {
      if (
        sslcCerficates[5].PCYearpassing !== null &&
        sslcCerficates[5].PCYearpassing !== "" &&
        sslcCerficates[5].PCYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[5].PCYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PCYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Professional Courses") {
              return { ...q, ["PCYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PCYearpassing"]: "",
        });
      }
    } else if (dname === "OtYearpassing") {
      if (
        sslcCerficates[6].OtYearpassing !== null &&
        sslcCerficates[6].OtYearpassing !== "" &&
        sslcCerficates[6].OtYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[6].OtYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["OtYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Others") {
              return { ...q, ["OtYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["OtYearpassing"]: "",
        });
      }
    }
  };

  const handleMonthChange_month = (month, dname) => {
    if (dname === "UGYearpassing") {
      if (
        sslcCerficates[0].UGYearpassing !== null &&
        sslcCerficates[0].UGYearpassing !== "" &&
        sslcCerficates[0].UGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[0].UGYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["UGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "UG") {
              return { ...q, ["UGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["UGYearpassing"]: "",
        });
      }
    } else if (dname === "PGYearpassing") {
      if (
        sslcCerficates[1].PGYearpassing !== null &&
        sslcCerficates[1].PGYearpassing !== "" &&
        sslcCerficates[1].PGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[1].PGYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "PG") {
              return { ...q, ["PGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PGYearpassing"]: "",
        });
      }
    } else if (dname === "IPYearpassing") {
      if (
        sslcCerficates[2].IPYearpassing !== null &&
        sslcCerficates[2].IPYearpassing !== "" &&
        sslcCerficates[2].IPYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[2].IPYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["IPYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Integrated PG") {
              return { ...q, ["IPYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["IPYearpassing"]: "",
        });
      }
    } else if (dname === "DYearpassing") {
      if (
        sslcCerficates[4].DYearpassing !== null &&
        sslcCerficates[4].DYearpassing !== "" &&
        sslcCerficates[4].DYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[4].DYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["DYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Diploma") {
              return { ...q, ["DYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["DYearpassing"]: "",
        });
      }
    } else if (dname === "PCYearpassing") {
      if (
        sslcCerficates[5].PCYearpassing !== null &&
        sslcCerficates[5].PCYearpassing !== "" &&
        sslcCerficates[5].PCYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[5].PCYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PCYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Professional Courses") {
              return { ...q, ["PCYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PCYearpassing"]: "",
        });
      }
    } else if (dname === "OtYearpassing") {
      if (
        sslcCerficates[6].OtYearpassing !== null &&
        sslcCerficates[6].OtYearpassing !== "" &&
        sslcCerficates[6].OtYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[6].OtYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["OtYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Others") {
              return { ...q, ["OtYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["OtYearpassing"]: "",
        });
      }
    }
  };

  // education cerficate handle change
  const handleEdu = (eduname, event) => {
    const names = event.target.name;
    const value = event.target.value;
    const files = event.target.files;

    if (names === "SSLC_Path" && files && files.length > 0) {
      const SSLC_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("SSLC_Path", SSLC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            SSLC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            SSLC_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          SSLC_Path: err,
        });
      }
    } else if (names === "PHD_Path" && files && files.length > 0) {
      const PHD_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("phd_path", PHD_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            PHD_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            PHD_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          PHD_Path: err,
        });
      }
    } else if (names === "HSC_Path" && files && files.length > 0) {
      const HSC_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("HSC_Path", HSC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            HSC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            HSC_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          HSC_Path: err,
        });
      }

      const UG_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("UG_Path", UG_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            UG_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            UG_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          UG_Path: err,
        });
      }
    } else if (names === "UG_Path" && files && files.length > 0) {
      const UG_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("UG_Path", UG_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            UG_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            UG_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          UG_Path: err,
        });
      }
    } else if (names === "PG_Path" && files && files.length > 0) {
      const PG_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("PG_Path", PG_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            PG_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            PG_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          PG_Path: err,
        });
      }
    } else if (names === "IP_Path" && files && files.length > 0) {
      const IP_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("IP_Path", IP_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            IP_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            IP_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          IP_Path: err,
        });
      }
    } else if (names === "PC_Path" && files && files.length > 0) {
      const PC_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("PC_Path", PC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            PC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            PC_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          PC_Path: err,
        });
      }
    } else if (names === "D_Path" && files && files.length > 0) {
      const D_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("D_Path", D_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            D_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            D_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          D_Path: err,
        });
      }
    } else if (names === "Ot_Path" && files && files.length > 0) {
      const Ot_Path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("Ot_Path", Ot_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            Ot_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            Ot_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          Ot_Path: err,
        });
      }
    } else if (names === "PG") {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === eduname) {
            return { ...q, [names]: value };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [names]: "",
      });
    } else if (names === "PHDMarksPercentage") {
      if (value < 0 || value == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "PGMarksPercentage") {
      if (value < 0 || value == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "UGMarksPercentage") {
      if (value < 0 || value == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "IPMarksPercentage") {
      if (value < 0 || value == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "DMarksPercentage") {
      if (value < 0 || value == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "PCMarksPercentage") {
      if (value < 0 || value == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "OtMarksPercentage") {
      if (value < 0 || value == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (
      names === "UGYearpassing" ||
      names === "PGYearpassing" ||
      names === "IPYearpassing" ||
      names === "DYearpassing" ||
      names === "PCYearpassing" ||
      names === "PHDYearpassing" ||
      names === "OtYearpassing"
    ) {
      if (setMaxMonthYear(value, names)) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === eduname) {
            return { ...q, [names]: value };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [names]: "",
      });
    }
  };
  const handlePrevious = () => {
    setStep(step - 1);
  };
  //step handle next button click
  const handleNext = () => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;
        const AdmissionRef_validation = {
          firstName: txtAdFname,
          lastName: txtAdLname,
          age: txtAdAge,
          mdob: txtAdMDob,
          mStatus: txtAdMStatus,
          gender: txtAdGender,
          father: txtAdFath,
          place_of_birth: txtAdPlaceBrith,
          spouse_name: txtAdSpouse,
          Occupation: txtAdOccupation,
          pSize: txtAdPSize,
          ano: txtAdAno,
          apath: txtAdApath,
          panno: txtAdpno,
          Ppath: txtAdPpath,
          pno: txtAdPno,
          wno: txtAdWno,
          fpo: txtAdFpo,
          email: txtAdEmail,
          SPCcategory: txtAdSpc,
          phno: txtAdPhno,
          psname: txtAdPsname,

          parea: txtAdParea,
          pland: txtAdPland,
          ppost: txtAdPpost,
          ptaluk: txtAdPtaluk,
          ppincode: txtAdPpincode,
          pcity: txtAdPcity,
          pstate: txtAdPstate,
          pdistrict: txtAdPdistrict,
          perhno: txtAdPerhno,
          persname: txtAdPersname,
          perarea: txtAdPerarea,
          perland: txtAdPerland,
          pererpost: txtAdPererpost,
          pertaluk: txtAdPertaluk,
          perpincode: txtAdPerpincode,
          percity: txtAdPercity,
          perstate: txtAdPerstate,
          perdistrict: txtAdPerdistrict,
          education: txtAdEduc,
          eduUCer: txtAdUCer,
          eduUpass: txtAdUpass,
          eduUmarks: txtAdUmarks,
          eduUdeg: txtAdUdeg,
          eduUMaj: txtAdUMaj,
          eduUMajOther: txtAdUMajOther,
          eduPMajOther: txtAdPMajOther,
          eduPhdMajOther: txtAdPhdMajOther,
          eduIMajOther: txtAdIMajOther,
          eduDMajOther: txtAdDMajOther,
          eduCMajOther: txtAdCMajOther,
          eduUclass: txtAdUclass,
          eduUins: txtAdUins,
          eduUfile: txtAdUfile,
          eduPCer: txtAdPCer,
          eduPpass: txtAdPpass,
          eduPmarks: txtAdPmarks,
          eduPdeg: txtAdPdeg,
          eduPMaj: txtAdPMaj,
          eduPclass: txtAdPclass,
          eduPins: txtAdPins,
          eduPfile: txtAdPfile,
          eduPhdCer: txtAdPhdCer,
          eduPhdpass: txtAdPhdpass,
          eduPhdmarks: txtAdPhdmarks,
          eduPhddeg: txtAdPhddeg,
          eduPhdMaj: txtAdPhdMaj,
          eduPhdclass: txtAdPhdclass,
          eduPhdins: txtAdPhdins,
          eduPhdfile: txtAdPhdfile,
          eduICer: txtAdICer,
          eduIpass: txtAdIpass,
          eduImarks: txtAdImarks,
          eduIdeg: txtAdIdeg,
          eduIMaj: txtAdIMaj,
          eduIclass: txtAdIclass,
          eduIins: txtAdIins,
          eduIfile: txtAdIfile,
          eduDCer: txtAdDCer,
          eduDpass: txtAdDpass,
          eduDmarks: txtAdDmarks,
          eduDdeg: txtAdDdeg,
          eduDMaj: txtAdDMaj,
          eduDclass: txtAdDclass,
          eduDins: txtAdDins,
          eduDfile: txtAdDfile,
          eduCCer: txtAdCCer,
          eduCpass: txtAdCpass,
          eduCmarks: txtAdCmarks,
          eduCdeg: txtAdCdeg,
          eduCMaj: txtAdCMaj,
          eduCclass: txtAdCclass,
          eduCins: txtAdCins,
          eduCfile: txtAdCfile,
          eduOCer: txtAdOCer,
          eduOpass: txtAdOpass,
          eduOmarks: txtAdOmarks,
          eduOdeg: txtAdOdeg,
          eduOMaj: txtAdOMaj,
          eduOclass: txtAdOclass,
          eduOins: txtAdOins,
          eduOfile: txtAdOfile,
          spc: txtAdSpc,
          des: txtAdDes,
          djoin: txtAdDjoin,
          location: txtfacLoc,
          workingexp: txtAdWorkingexp,
          teachingexp: txtAdTeachingexp,
          VoiceOpinion: txtAdVoicepp,
          Teaching_ex_file: txtTfile,
          working_ex_file: txtWfile,
        };

        const errors = validateProfile(
          list,
          sslcCerficates,
          educationQualification,
          step,
          category,
          subject,
          AdmissionRef_validation,
          techQualification,
          setTechQualification,
          list.staff_type
        );
        if (Object.keys(errors).length === 0) {
          if (step === 1) {
            const SteponeData = {
              step: 1,
              user_id: userId ? userId : userid,
              first_name: list.FirstName,
              last_name: list.LastName,
              father_name: list.Fathername,
              place_of_birth: list.PlaceBirth,
              dob: list.DOB,
              age: list.age,
              gender: list.gender,
              marital_status: list.MaritalStatus,
              spouse_name: list.Spouse,
              spouse_ocp: list.Occupation,
              profile_path: list.Profilephoto,
              aadhar_no: list.aadharNo,
              original_aadhar_path: list.original_aadhar_path,
              original_profile_path: list.original_profile_path,
              original_pan_path: list.original_pan_path,
              aadhar_path: list.aadharCardphoto,
              pan_no: list.panNo,
              pan_path: list.panPhoto,
              mobile_no: list.Mobile,
              country_code: list.MobileCode,
              whatsapp_no:
                list.ContactNumber === true ? list.Mobile : list.WhatsAppNumber,
              contact_type: list.ContactNumber === true ? "1" : "0",
              email: list.emailaddress,
              created_by: userid,
            };
             setIsLoading(true);
            // console.log(SteponeData);
            AxiosInstance.post("/api/staff/add", SteponeData)
              .then((res) => {
                   setIsLoading(false);
                if (res.data.status === true) {
                  setStep(step + 1);
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          } else if (step === 2) {
            const address = [
              {
                address1: list.BuildingNumberPresent,
                address2: list.StreetNamePresent,
                address3: list.AreaPresent,
                landmark: list.LandmarkPresent,
                post_name: list.PostPresent,
                taluk: list.TalukPresent,
                postal_code: list.PincodePresent ? list.PincodePresent : 0,
                city: list.CityPresent,
                district_name: list.districtPresent,
                state_name: list.statePresent,
                same_address: list.SamePresentAddress == true ? "0" : "1",
                address_type: "1",
              },
              {
                address1:
                  list.SamePresentAddress == true
                    ? list.BuildingNumberPresent
                    : list.BuildingNumberPermanent,
                address2:
                  list.SamePresentAddress == true
                    ? list.StreetNamePresent
                    : list.StreetNamePermanent,
                address3:
                  list.SamePresentAddress == true
                    ? list.AreaPresent
                    : list.AreaPermanent,
                landmark:
                  list.SamePresentAddress == true
                    ? list.LandmarkPresent
                    : list.LandmarkPermanent,
                post_name:
                  list.SamePresentAddress == true
                    ? list.PostPresent
                    : list.PostPermanent,
                taluk:
                  list.SamePresentAddress == true
                    ? list.TalukPresent
                    : list.TalukPermanent,
                postal_code:
                  list.SamePresentAddress == true
                    ? list.PincodePresent
                      ? list.PincodePresent
                      : 0
                    : list.PincodePermanent
                    ? list.PincodePermanent
                    : 0,
                city:
                  list.SamePresentAddress == true
                    ? list.CityPresent
                    : list.CityPermanent,
                district_name:
                  list.SamePresentAddress == true
                    ? list.districtPresent
                    : list.districtPermanent,
                state_name:
                  list.SamePresentAddress == true
                    ? list.statePresent
                    : list.statePermanent,
                same_address: list.SamePresentAddress == true ? "0" : "1",
                address_type: "2",
              },
            ];
            const StepTwoData = {
              step: 2,
              user_id: userId ? userId : userid,
              address: address,
              updated_by: userid,
            };
              setIsLoading(true);
            // console.log(StepTwoData);
            AxiosInstance.post("/api/staff/add", StepTwoData)
              .then((res) => {
                   setIsLoading(false);
                // console.log(res);
                if (res.data.status === true) {
                  setStep(step + 1);
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          } else if (step === 3) {
            const errors_thq = validateThq(
              techQualification,
              setTechQualification
            );
            if (
              errors_thq.length > 0 &&
              errors_thq.every(
                (el) =>
                  el.error_name === "" &&
                  el.error_certificate_no === "" &&
                  el.error_year_of_passing === "" &&
                  el.error_level === "" &&
                  el.error_grade === "" &&
                  el.error_kComputer === ""
              )
            ) {
              const filteredDetails = sslcCerficates.filter((detail) => {
                let cert = detail.name;
                if (detail.name === "UG") {
                  detail.UGMajor =
                    uGisOther === true ? detail.UGMajor_Other : detail.UGMajor;
                  detail.type_of_degree = uGisOther === true ? 1 : 0;
                } else if (detail.name === "PG") {
                  detail.PGMajor =
                    pGisOther === true ? detail.PGMajor_Other : detail.PGMajor;
                  detail.type_of_degree = pGisOther === true ? 1 : 0;
                } else if (detail.name === "Integrated PG") {
                  detail.IPMajor =
                    iPGisOther === true ? detail.IPMajor_Other : detail.IPMajor;
                  detail.type_of_degree = iPGisOther === true ? 1 : 0;
                } else if (detail.name === "phd") {
                  detail.PHDMajor =
                    pHDisOther === true
                      ? detail.PHDMajor_Other
                      : detail.PHDMajor;
                  detail.type_of_degree = pHDisOther === true ? 1 : 0;
                } else if (detail.name === "Diploma") {
                  detail.DMajor =
                    dipisOther === true ? detail.DMajor_Other : detail.DMajor;
                  detail.type_of_degree = dipisOther === true ? 1 : 0;
                } else if (detail.name === "Professional Courses") {
                  detail.PCMajor =
                    pCisOther === true ? detail.PCMajor_Other : detail.PCMajor;
                  detail.type_of_degree = pCisOther === true ? 1 : 0;
                } else if (detail.name === "Others") {
                  detail.type_of_degree = 1;
                }
                return educationQualification.includes(cert);
              });

              const TQ = techQualification.map((item) => ({
                id: item.id,
                name: item.name,
                level:
                  item.name !== "Knowledge in computer"
                    ? item.level
                    : item.level,
                lang: item.lang,
                Cnum: item.Cnum,
                kdg_in_com:
                  item.name === "Knowledge in computer" ? item.level : "",
                grade: item.grade,
                year: item.year,
                file: item.file,
                original_file_path:
                  item.original_file_path !== null &&
                  item.original_file_path !== "null"
                    ? item.original_file_path
                    : null,
                type_of_degree: 0,
              }));
              const StepThreeData = {
                user_id: userId ? userId : userid,
                updated_by: userid,
                step: 3,
                edu_details: filteredDetails,
                tech_qualification: TQ,
                special_qualification: list.spq,
              };
                setIsLoading(true);
              // console.log(StepThreeData);
              AxiosInstance.post("/api/staff/add", StepThreeData)
                .then((res) => {
                     setIsLoading(false);
                  // console.log(res);
                  if (res.data.status === true) {
                    setStep(step + 1);
                  } else {
                    toast.error(res.data.message);
                  }
                })
                .catch((error) => {
                  return error;
                });
            }
          } else if (step === 4) {
            const newData = [];
            const NewPk = [];
            subject.forEach((item) => {
              item.optionSelected.forEach((option) => {
                newData.push({
                  category: item.category,
                  subject: option.value.trim(),
                  subject_pk: option.pk,
                });
                NewPk.push(option.pk);
              });
            });

            const cates = subject.map((item) => item.category || null);
            const StepFourData = {
              step: 4,
              is_eligible_class: list.teachType,
              user_id: userId ? userId : userid,
              experience: list.prevTeachexp === "Yes" ? 1 : 0,
              working_exp: list.workingexp,
              teaching_exp: list.teachexp,
              working_exp_filepath: list.working_ex_file,
              teaching_exp_filepath: list.Teaching_ex_file,
              original_workexp: list.original_workexp,
              original_teachexp: list.original_teachexp,
              staff_type: parseInt(list.staff_type),
              category: (cates.length > 0 && cates) || null,
              designation: list.designation,
              designation_id: list.designation_id,
              subject: newData,
              subject_pk: NewPk.length > 0 ? NewPk : null,
              aiasa_doj: list.DJoin || null,
              location: list.location_id,
              feedback: list.VoiceOpinion,
              updated_by: userid,
              created_by: userid,
              job_info: list.staff_type === 3 ? addJob : [],
            };
  setIsLoading(true);
            AxiosInstance.post("/api/staff/add", StepFourData)
              .then((res) => {
                   setIsLoading(false);
                if (res.data.status === true) {
                  setStep(step + 1);
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((error) => {
                return error;
              });
          }
        } else {
          setListErrors(errors);
        }
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
    // setStep(step + 1);
  };

  //dob convert to age function
  const DobCovertAge = (dob) => {
    var ageInYears = moment().diff(dob, "years", false);

    // const dobDate = new Date(dob);
    // const now = new Date();
    // const ageInMs = now - dobDate;
    // const ageInYears = Math.floor(ageInMs / 31536000000); // 1 year ≈ 31536000000 ms

    return ageInYears;
  };
  //handlechange event

  const handleChangeDate = (date, name) => {
    const dateDOB = moment(date).format("YYYY-MM-DD");
    // console.log(name, "name", dateDOB);
    const age = DobCovertAge(date);
    if (age >= 18 && age <= 60) {
      setList({
        ...list,
        [name]: dateDOB,
        ["age"]: age,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
        ["age"]: "",
      });
    } else {
      const err =
        "Please select a DOB for autofill with an age between 18 and 60 years";
      setList({
        ...list,
        age: "",
      });
      setListErrors({
        ...listErrors,
        DOB: err,
      });
    }
  };

  const handleSelectCH = (option, dname) => {
    // console.log(option,dname);
    setList((prevState) => ({
      ...prevState,
      [dname]: option.value,
    }));

    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };
  // all date format should handle function
  const handleChangeCuDate = (dates, name) => {
    const dateSam = moment(dates).format("YYYY-MM-DD");
    setList((prevState) => ({
      ...prevState,
      [name]: dateSam,
    }));
    setListErrors({
      ...listErrors,
      [name]: "",
    });
  };

  //handlechange function

  const handleChange = (event) => {
    const { name, value, files, checked } = event.target;
    if (name === "ContactNumber") {
      setList((prevList) => ({
        ...prevList,
        [name]: checked,
        WhatsAppNumber: checked ? prevList.Mobile : "",
      }));

      setListErrors((prevErrors) => ({
        ...prevErrors,
        WhatsAppNumber: "",
      }));
      return; // stop further execution
    } else if (name === "PincodePresent") {
      if (/^[1-9][0-9]{5}$/.test(value) || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          ["CityPresent"]: "",
        }));
        setListErrors({
          ...listErrors,
          ["PincodePresent"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          ["CityPresent"]: "",
        }));
        setListErrors({
          ...listErrors,
          ["PincodePresent"]: "Please Enter valid Pincode",
        });
        return;
      }
    } else if (name === "PincodePermanent") {
      if (/^[1-9][0-9]{5}$/.test(value) || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          ["CityPermanent"]: "",
        }));
        setListErrors({
          ...listErrors,
          ["PincodePermanent"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
          ["CityPermanent"]: "",
        }));
        setListErrors({
          ...listErrors,
          ["PincodePermanent"]: "Please Enter valid Pincode",
        });
        return;
      }
    } else if (name === "Mobile") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["Mobile"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["Mobile"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name === "WhatsAppNumber") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name == "aadharNo") {
      if (value.length === 12 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["aadharNo"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["aadharNo"]: "Please Enter valid 12 digit number",
        });
        return;
      }
    } else if (name == "panNo") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["panNo"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["panNo"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name == "SamePresentAddress") {
      setList((prevList) => ({
        ...prevList,
        [name]: checked,
      }));
      setListErrors({
        ...listErrors,
        ["SamePresentAddress"]: "",
        ["BuildingNumberPermanent"]: "",
        ["StreetNamePermanent"]: "",
        ["AreaPermanent"]: "",
        ["LandmarkPermanent"]: "",
        ["districtPermanent"]: "",
        ["CityPermanent"]: "",
        ["statePermanent"]: "",
        ["PostPermanent"]: "",
        ["TalukPermanent"]: "",
        ["PincodePermanent"]: "",
      });
    } else if (name === "Profilephoto" && files && files.length > 0) {
      const profile_path = files[0];
      // console.log(profile_path);
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 40 * 1024) {
          const formData = new FormData();
          formData.append("profile_path", profile_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                Profilephoto: res.data.path,
                original_profile_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                Profilephoto: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 40KB.";
          setListErrors({
            ...listErrors,
            Profilephoto: err,
          });
        }
      } else {
        let err = "(Png , jpg ,jpeg )images only allowed";
        setListErrors({
          ...listErrors,
          Profilephoto: err,
        });
      }
    } else if (name === "aadharCardphoto" && files && files.length > 0) {
      const aadhar_path = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("aadhar_path", aadhar_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                aadharCardphoto: res.data.path,
                original_aadhar_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                aadharCardphoto: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            aadharCardphoto: err,
          });
        }
      } else {
        let err = "pdf and img files only allowed";
        setListErrors({
          ...listErrors,
          aadharCardphoto: err,
        });
      }
    } else if (name === "panPhoto" && files && files.length > 0) {
      const pan_path = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("pan_path", pan_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                panPhoto: res.data.path,
                original_pan_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                panPhoto: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            panPhoto: err,
          });
        }
      } else {
        let err = "pdf and img files only allowed";
        setListErrors({
          ...listErrors,
          panPhoto: err,
        });
      }
    } else if (name == "Verify") {
      setList((prevList) => ({
        ...prevList,
        [name]: checked,
      }));
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name == "categoryJob") {
      if (checked) {
        setCategoryJob([...categoryJob, value]);
      } else {
        setCategoryJob(categoryJob.filter((item) => item !== value));
      }
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name == "USub") {
      const selectedOptions = Array.from(event.target.selectedOptions);
      const selectedValues = selectedOptions.map((option) => option.value);
      // console.log(selectedValues, "selectedValues");
      setList({
        ...list,
        [name]: selectedValues,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name == "spq") {
      setList({
        ...list,
        [name]: value,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name == "VoiceOpinion") {
      setList({
        ...list,
        [name]: value,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name === "Adminstatus") {
      if (checked) {
        setList((prevFields) => ({
          ...prevFields,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          [name]: "",
        });
      }
    } else if (name === "working_ex_file" && files && files.length > 0) {
      const working_ex_file = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("faculty_exp", working_ex_file);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                working_ex_file: res.data.path,
                original_workexp: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                working_ex_file: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            working_ex_file: err,
          });
        }
      } else {
        let err = "pdf and img files only allowed";
        setListErrors({
          ...listErrors,
          working_ex_file: err,
        });
      }
    } else if (name === "Teaching_ex_file" && files && files.length > 0) {
      const Teaching_ex_file = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("faculty_exp", Teaching_ex_file);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                Teaching_ex_file: res.data.path,
                original_teachexp: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                Teaching_ex_file: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            Teaching_ex_file: err,
          });
        }
      } else {
        let err = "pdf and img files only allowed";
        setListErrors({
          ...listErrors,
          Teaching_ex_file: err,
        });
      }
    } else if (name === "designation_id") {
      const selected = designation.find((item) => item.value === value);
      setList((prev) => ({
        ...prev,
        designation: selected ? selected.label : "",
        designation_id: value,
      }));
      setListErrors((prev) => ({
        ...prev,
        designation: "",
      }));
    } else if (name === "location_id") {
      const selectedLocation = locations.find((loc) => loc.value === value);
      setList((prev) => ({
        ...prev,
        location: selectedLocation ? selectedLocation.label : "",
        location_id: value,
      }));
      setListErrors((prev) => ({
        ...prev,
        location: "",
      }));
    } else {
      setList({
        ...list,
        [name]: value,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    }
  };
  const handleStepPrevious = (count) => {
    setStep(count);
  };

  const validateThq = (techQualification, setTechQualification) => {
    if (techQualification && techQualification.length > 0) {
      const updateTHQ = techQualification.map((OB) => {
        let updatedOB = { ...OB };
        // console.log(techQualification,"techQualification");
        if (!OB.name) {
          updatedOB.error_name = "Name is required";
        }
        if (OB.name === "Nil") {
          updatedOB.error_name = "";
          updatedOB.error_level = "";
          updatedOB.error_edu_medium = "";
          updatedOB.error_certificate_no = "";
          updatedOB.error_year_of_passing = "";
          updatedOB.error_grade = "";
          updatedOB.error_kComputer = "";
        }
        if (!OB.level && OB.name !== "Nil") {
          updatedOB.error_level = "Level is required";
        }

        // if (!OB.kComputer && OB.name !== "Nil") {
        //   updatedOB.error_kComputer = "Knowlege of computer is required";
        // }

        if (!OB.lang && OB.name !== "Nil") {
          updatedOB.error_edu_medium = "Lang is required";
        }

        if (!OB.Cnum && OB.name !== "Nil") {
          updatedOB.error_certificate_no = "Certificate No is required";
        }

        if (!OB.year && OB.name !== "Nil") {
          updatedOB.error_year_of_passing = "Year of passing is required";
        }

        if (!OB.grade && OB.name !== "Nil") {
          updatedOB.error_grade = "Grade is required";
        }

        return updatedOB;
      });
      setTechQualification(updateTHQ);
      return updateTHQ;
    }
  };

  const steps = [
    {
      header: "Personal Profile",
      subheader: "Define Your Identity",
    },
    {
      header: "Communication",
      subheader: "Stay Connected Always",
    },
    {
      header: "Academic Background",
      subheader: "Your Learning Journey",
    },
    {
      header: "Employment Details",
      subheader: "Career Snapshot",
    },
    {
      header: "Review and Confirm",
      subheader: "Review Your Details",
    },
  ];

  const handleAddJobinfo = () => {
    setAddJob((prevState) => [
      ...prevState,
      {
        id: prevState.length > 0 ? prevState.length + 1 : 1,
        department: "",
        exp_designation: "",
      },
    ]);
  };

  const DeleteAddJobinfo = (id, name) => {
    setAddJob((prevState) =>
      prevState
        .filter((item) => item.id !== id)
        .map((item, index) => ({ ...item, id: index + 1 }))
    );
  };

  const handleChangeAjob = (e, id) => {
    const { name, value } = e.target;
    setAddJob((prevState) => {
      return prevState.map((q) => {
        if (q.id === id) {
          return { ...q, [name]: value };
        }
        return q;
      });
    });
  };

  const handleChangeAjobs = (option, id, name, index) => {
    if (!option) return;

    // Update job data
    setAddJob((prevState) =>
      prevState.map((q) => {
        if (q.id === id) {
          if (name === "department") {
            return {
              ...q,
              department: option.label,
              department_id: option.value,
              exp_designation: "",
              designation_id: "",
            };
          } else if (name === "exp_designation") {
            return {
              ...q,
              exp_designation: option.label,
              designation_id: option.value,
            };
          }
        }
        return q;
      })
    );

    // Update error
    setErrDep((prevErr) =>
      prevErr.map((err, index) => {
        const jobIndex = addJob.findIndex((item) => item.id === id);
        if (index !== jobIndex) return err;

        const updatedErr = { ...err };

        if (name === "department") {
          // Clear department error
          delete updatedErr.department;
          // Also clear designation error since it's reset
          delete updatedErr.designation;
        } else if (name === "exp_designation") {
          // Clear designation error
          delete updatedErr.designation;
        }

        return updatedErr;
      })
    );

    if (name === "department") {
      GetDesignation(option.id, index);
    }
  };

  // useEffect(() => {
  //   if (addJob && addJob.length > 0) {
  //     addJob.forEach((job, index) => {
  //       if (job.department_id && job.department_id !== "") {
  //         GetDesignation(job.department_id, index);
  //       }
  //     });
  //   }
  // }, [addJob]);

  return isLoading ? (
      <div
        className="loaderApi"
        style={{
          display: isLoading ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "white",
          zIndex: 999,
        }}
      >
        {isLoading && <Loader />}
      </div>
    ) : (
    <div className="FProfile BathHeader global_container">
      {userId ? (
        <h2 className="TitleHeader mb-0">
          {list.staff_type === 0
            ? "Faculty Profile"
            : list.staff_type === 1
            ? "Staff Profile"
            : "Panel Member Profile"}
        </h2>
      ) : (
        <h2 className="TitleHeader mb-0">My Profile</h2>
      )}
      <div className="BathHeader global_container">
        <div className="stepperIcon">
          <div className="stepperIcon">
            <Stepper activeStep={step - 1}>
              {steps.map((section, index) => {
                const stepProps = {};
                const labelProps = {};

                return (
                  <Step key={index} {...stepProps}>
                    <StepLabel {...labelProps}>
                      <div className="text-center mt-2">
                        <p
                          className="form-label confirm_value"
                          style={{
                            color:
                              step === index + 1 || step > index + 1
                                ? "#c0272d"
                                : "#041134",
                            fontWeight:
                              step === index + 1 || step > index + 1
                                ? "600"
                                : "normal",
                          }}
                        >
                          {section.header}
                        </p>
                        <p
                          style={{
                            color:
                              step === index + 1 || step > index + 1
                                ? "#041134"
                                : "gray",
                            fontSize: "12px",
                            fontWeight:
                              step === index + 1 || step > index + 1
                                ? "600"
                                : "normal",
                          }}
                        >
                          {section.subheader}
                        </p>
                      </div>
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>
        </div>

        <div
          className={`d-flex my-4 ${
            step === 1 ? "justify-content-end" : "justify-content-between"
          }`}
        >
          {/* Left Side Back Button */}
          {step !== 1 && (
            <button
              type="button"
              className={`${styles.SaveButton}`}
              // onClick={handleBack}
              onClick={handlePrevious}
            >
              <span className={styles.arrowIconL}>&larr;</span>
              <span className={styles.buttonTextL}>
                Go to {steps[step - 2]?.header}
              </span>
            </button>
          )}
          {/* <Link to="/Faculties/1" className="CancelButton">
                          Back to Faculties
                        </Link> */}

          {/* Right Side Next/Save Button */}
          <button
            type="button"
            className={`${styles.SaveButton}`}
            // onClick={neHandleNext}
            onClick={step === steps.length ? handleSubmit : handleNext}
          >
            <span className={styles.buttonText}>
              {step === steps.length
                ? "Save Profile"
                : `Save & Continue to ${steps[step]?.header}`}
            </span>
            <span className={styles.arrowIcon}>&rarr;</span>
          </button>
        </div>

        {/* STEP 1 */}
        {step === 1 && (
          <FacultyProfileStep1
            list={list}
            listErrors={listErrors}
            handleChange={handleChange}
            styles={styles}
            txtAdPpath={txtAdPpath}
            txtAdFname={txtAdFname}
            txtAdLname={txtAdLname}
            txtAdFath={txtAdFath}
            txtAdMDob={txtAdMDob}
            handleChangeDate={handleChangeDate}
            txtAdAge={txtAdAge}
            txtAdPlaceBrith={txtAdPlaceBrith}
            txtAdGender={txtAdGender}
            txtAdMStatus={txtAdMStatus}
            txtAdSpouse={txtAdSpouse}
            txtAdOccupation={txtAdOccupation}
            txtAdPno={txtAdPno}
            txtAdWno={txtAdWno}
            txtAdEmail={txtAdEmail}
            txtAdPSize={txtAdPSize}
            txtAdAno={txtAdAno}
            txtAdpno={txtAdpno}
            txtAdApath={txtAdApath}
          />
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <FacultyProfileStep2
            list={list}
            styles={styles}
            listErrors={listErrors}
            handleChange={handleChange}
            handleSelectCH={handleSelectCH}
            city={city}
            txtAdPhno={txtAdPhno}
            txtAdPsname={txtAdPsname}
            txtAdParea={txtAdParea}
            txtAdPland={txtAdPland}
            txtAdPpost={txtAdPpost}
            txtAdPtaluk={txtAdPtaluk}
            txtAdPpincode={txtAdPpincode}
            txtAdPcity={txtAdPcity}
            txtAdPdistrict={txtAdPdistrict}
            txtAdPerhno={txtAdPerhno}
            txtAdPersname={txtAdPersname}
            txtAdPerarea={txtAdPerarea}
            txtAdPerland={txtAdPerland}
            txtAdPererpost={txtAdPererpost}
            txtAdPertaluk={txtAdPertaluk}
            txtAdPerpincode={txtAdPerpincode}
            txtAdPercity={txtAdPercity}
            txtAdPerdistrict={txtAdPerdistrict}
            txtAdPerstate={txtAdPerstate}
          />
        )}

        {/* STEP 3 */}
        {step === 3 && (
          <FacultyProfileStep3
            staff_type={list.staff_type}
            styles={styles}
            educationQualification={educationQualification}
            handleChange={handleChange}
            handleCheckboxChange={handleCheckboxChange}
            handleEdu={handleEdu}
            handleYearChange_month={handleYearChange_month}
            handleMonthChange_month={handleMonthChange_month}
            handleEYDate={handleEYDate}
            txtAdEduc={txtAdEduc}
            listErrors={listErrors}
            sslcCerficates={sslcCerficates}
            handleEdus={handleEdus}
            list={list}
            ipMajor={ipMajor}
            ugOption={ugOption}
            pgDegree={pgDegree}
            ugDegree={ugDegree}
            iPGisOther={iPGisOther}
            pgMajor={pgMajor}
            ipgDegree={ipgDegree}
            handleEduMajor={handleEduMajor}
            mOption={mOption}
            major={major}
            uGisOther={uGisOther}
            classOption={classOption}
            txtAdUdeg={txtAdUdeg}
            txtAdUMaj={txtAdUMaj}
            dmajor={dmajor}
            txtAdUMajOther={txtAdUMajOther}
            txtAdUpass={txtAdUpass}
            txtAdUCer={txtAdUCer}
            txtAdUmarks={txtAdUmarks}
            txtAdUclass={txtAdUclass}
            txtAdUins={txtAdUins}
            txtAdUfile={txtAdUfile}
            txtAdPdeg={txtAdPdeg}
            diplomaDegree={diplomaDegree}
            txtAdPMaj={txtAdPMaj}
            pcDegree={pcDegree}
            phDegree={phDegree}
            pcMajor={pcMajor}
            txtAdPhdMaj={txtAdPhdMaj}
            PhMajor={PhMajor}
            pHDisOther={pHDisOther}
            pGisOther={pGisOther}
            txtAdPMajOther={txtAdPMajOther}
            txtAdPpass={txtAdPpass}
            txtAdPCer={txtAdPCer}
            txtAdPmarks={txtAdPmarks}
            txtAdPclass={txtAdPclass}
            txtAdPins={txtAdPins}
            txtAdPfile={txtAdPfile}
            txtAdIfile={txtAdIfile}
            txtAdIdeg={txtAdIdeg}
            txtAdIMaj={txtAdIMaj}
            txtAdIMajOther={txtAdIMajOther}
            txtAdIpass={txtAdIpass}
            txtAdICer={txtAdICer}
            txtAdImarks={txtAdImarks}
            txtAdIclass={txtAdIclass}
            txtAdIins={txtAdIins}
            txtAdPhddeg={txtAdPhddeg}
            txtAdPhdMajOther={txtAdPhdMajOther}
            txtAdPhdpass={txtAdPhdpass}
            txtAdPhdCer={txtAdPhdCer}
            txtAdPhdmarks={txtAdPhdmarks}
            txtAdPhdclass={txtAdPhdclass}
            txtAdPhdins={txtAdPhdins}
            txtAdPhdfile={txtAdPhdfile}
            txtAdDfile={txtAdDfile}
            txtAdDins={txtAdDins}
            txtAdDclass={txtAdDclass}
            txtAdDmarks={txtAdDmarks}
            txtAdDCer={txtAdDCer}
            txtAdDpass={txtAdDpass}
            txtAdDMajOther={txtAdDMajOther}
            dipisOther={dipisOther}
            txtAdDMaj={txtAdDMaj}
            txtAdDdeg={txtAdDdeg}
            txtAdCfile={txtAdCfile}
            txtAdCins={txtAdCins}
            txtAdCclass={txtAdCclass}
            txtAdCmarks={txtAdCmarks}
            txtAdCCer={txtAdCCer}
            txtAdCpass={txtAdCpass}
            txtAdCMajOther={txtAdCMajOther}
            pCisOther={pCisOther}
            txtAdCMaj={txtAdCMaj}
            txtAdCdeg={txtAdCdeg}
            txtAdOfile={txtAdOfile}
            txtAdOins={txtAdOins}
            txtAdOclass={txtAdOclass}
            txtAdOmarks={txtAdOmarks}
            txtAdOCer={txtAdOCer}
            txtAdOpass={txtAdOpass}
            txtAdOMaj={txtAdOMaj}
            txtAdOdeg={txtAdOdeg}
            txtAdSpc={txtAdSpc}
            // Technical Qualification Props
            AddQualification={AddQualification}
            DeleteQual={DeleteQual}
            techQualification={techQualification}
            technicalOption={technicalOption}
            TechhandleChange_date={TechhandleChange_date}
            TechhandleChange={TechhandleChange}
            TechhandleChanges={TechhandleChanges}
            txtadTech={txtadTech}
            handleAdd={AddQualification}
          />
        )}

        {step === 4 && (
          <FacultyProfileStep4
            staff_type={list.staff_type}
            user_type={user_type}
            list={list}
            listErrors={listErrors}
            handleChange={handleChange}
            txtAdWorkingexp={txtAdWorkingexp}
            txtAdTeachingexp={txtAdTeachingexp}
            txtWfile={txtWfile}
            txtAdDes={txtAdDes}
            designation={designation}
            txtAdDjoin={txtAdDjoin}
            handleChangeCuDate={handleChangeCuDate}
            locations={locations}
            txtfacLoc={txtfacLoc}
            txtAdVoicepp={txtAdVoicepp}
            //
            addJob={addJob}
            errDep={errDep}
            handleChangeAjob={handleChangeAjob}
            handleChangeAjobs={handleChangeAjobs}
            DeleteAddJobinfo={DeleteAddJobinfo}
            department={department}
            handleAddJobinfo={handleAddJobinfo}
          />
        )}
        {step === 5 && (
          <FacultyProfileStep5
            list={list}
            educationQualification={educationQualification}
            sslcCerficates={sslcCerficates}
            techQualification={techQualification}
            handleChange={handleChange}
            styles={styles}
            listErrors={listErrors}
            adminstatusRef={adminstatusRef}
            commentsRef={commentsRef}
            user_type={user_type}
          />
        )}

        <div
          className={`d-flex my-4 ${
            step === 1 ? "justify-content-end" : "justify-content-between"
          }`}
        >
          {/* Left Side Back Button */}
          {step !== 1 && (
            <button
              type="button"
              className={`${styles.SaveButton}`}
              // onClick={handleBack}
              onClick={handlePrevious}
            >
              <span className={styles.arrowIconL}>&larr;</span>
              <span className={styles.buttonTextL}>
                Go to {steps[step - 2]?.header}
              </span>
            </button>
          )}
          {/* <Link to="/Faculties/1" className="CancelButton">
                          Back to Faculties
                        </Link> */}

          {/* Right Side Next/Save Button */}
          <button
            type="button"
            className={`${styles.SaveButton}`}
            // onClick={neHandleNext}
            onClick={step === steps.length ? handleSubmit : handleNext}
          >
            <span className={styles.buttonText}>
              {step === steps.length
                ? "Save Profile"
                : `Save & Continue to ${steps[step]?.header}`}
            </span>
            <span className={styles.arrowIcon}>&rarr;</span>
          </button>
        </div>
      </div>
    </div>
  );
}
export default FacultyProfile;
